var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g, _path84, _path85, _path86, _path87, _path88, _path89, _g2, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g3, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g4, _path130, _g5, _path131, _g6, _path132, _g7, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _g8, _path158, _g9, _path159, _g0, _path160, _path161, _path162, _path163, _path164, _g1, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _g10, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _g11, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _g12, _path209, _g13, _path210, _g14, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _g15, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _g16, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoomersBookParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 67,
    viewBox: "0 0 82 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41161 28.5821C5.65275 27.6713 6.70652 27.2688 7.7205 27.6737C11.2652 29.0785 14.775 30.4448 18.2473 31.7267C14.5712 31.2448 10.8119 30.8279 6.98262 30.4327C5.88424 30.3219 5.16565 29.4918 5.41161 28.5821Z",
    fill: "#F26283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17726 40.454C8.98073 39.8516 9.45457 39.1287 10.231 38.8516C12.9306 37.8781 15.6566 36.9937 18.3598 36.2383C15.7654 37.5816 13.244 39.0612 10.8061 40.6709C10.0924 41.1372 9.36535 41.0552 9.17726 40.454Z",
    fill: "#FDA014"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4492 52.1782C11.8644 51.7866 11.9078 50.5589 12.5999 49.5058C15.0113 45.8359 17.7964 42.5334 20.6382 39.6406C18.3848 42.9985 16.223 46.6986 14.4108 50.736C13.8876 51.8926 13.0327 52.5685 12.4492 52.1782Z",
    fill: "#9FB603"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8309 14.315C23.3566 14.2476 23.7135 14.9922 23.6749 15.9524C23.5426 19.1991 23.641 22.4511 23.9691 25.6839C23.063 22.5734 22.4177 19.3929 22.04 16.1753C21.9254 15.2271 22.3064 14.3837 22.8309 14.315Z",
    fill: "#FDC63A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.273 14.3036C12.1362 13.5481 13.1683 13.9722 13.659 15.2241C15.3904 19.5868 17.7583 23.87 20.394 27.7375C17.0806 24.5476 13.9893 21.1352 11.1415 17.5241C10.3325 16.5084 10.4109 15.059 11.273 14.3036Z",
    fill: "#065FE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70728 34.7423C3.12927 34.8242 3.39452 35.3109 3.31012 35.8338C3.22572 36.3567 2.82785 36.723 2.40706 36.6495C1.98628 36.576 1.70656 36.0832 1.78734 35.5531C1.86812 35.023 2.28649 34.6603 2.70728 34.7423Z",
    fill: "#065FE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3569 27.0785C16.7488 27.199 16.9598 27.6629 16.832 28.1123C16.7042 28.5617 16.2798 28.8352 15.8807 28.7255C15.4816 28.6159 15.2634 28.1508 15.3984 27.6918C15.5334 27.2327 15.9627 26.9568 16.3569 27.0785Z",
    fill: "#FDA014"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1665 30.5274C24.5596 30.6479 24.7693 31.1117 24.6415 31.5599C24.5137 32.0081 24.0893 32.2828 23.6903 32.1744C23.2912 32.066 23.0729 31.5997 23.208 31.1406C23.343 30.6816 23.7722 30.4069 24.1665 30.5274Z",
    fill: "#FDA014"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1452 43.0417C21.2367 43.0411 21.3271 43.0614 21.4095 43.101C21.492 43.1405 21.5644 43.1983 21.6212 43.2699C21.678 43.3415 21.7177 43.4251 21.7374 43.5144C21.7571 43.6036 21.7562 43.6962 21.7348 43.785C21.6911 43.9835 21.5831 44.162 21.4274 44.2927C21.2717 44.4235 21.0771 44.4991 20.874 44.5079C20.4737 44.5079 20.2072 44.1754 20.2808 43.7622C20.3197 43.5609 20.427 43.3792 20.5845 43.2479C20.742 43.1166 20.9401 43.0438 21.1452 43.0417Z",
    fill: "#FDC63A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2359 18.5489C26.5615 18.7513 26.7182 19.2344 26.588 19.6332C26.4578 20.032 26.084 20.1947 25.744 20.0043C25.404 19.814 25.2449 19.3344 25.3823 18.9272C25.5198 18.52 25.9116 18.3501 26.2359 18.5489Z",
    fill: "#9FB603"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38453 34.307C7.69439 34.3673 7.88368 34.7167 7.81375 35.089C7.74382 35.4612 7.43758 35.7167 7.12772 35.6613C6.81786 35.6058 6.62012 35.2552 6.69126 34.8793C6.76239 34.5034 7.07467 34.2468 7.38453 34.307Z",
    fill: "#FDA014"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71854 23.2198C6.02117 23.3065 6.15862 23.6788 6.03081 24.0523C5.90301 24.4258 5.55577 24.6619 5.25074 24.5788C4.9457 24.4957 4.79981 24.1222 4.93123 23.7463C5.06265 23.3704 5.41712 23.1342 5.71854 23.2198Z",
    fill: "#9FB603"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1939 38.6465C17.267 38.6588 17.3367 38.686 17.3987 38.7265C17.4607 38.7669 17.5137 38.8198 17.5543 38.8816C17.595 38.9435 17.6224 39.0131 17.6349 39.0861C17.6473 39.159 17.6446 39.2338 17.6268 39.3056C17.601 39.4591 17.5197 39.5977 17.3983 39.6952C17.2769 39.7927 17.124 39.8423 16.9685 39.8345C16.6658 39.802 16.4693 39.5068 16.5308 39.1743C16.5552 39.0193 16.6368 38.8792 16.7596 38.7814C16.8824 38.6837 17.0373 38.6356 17.1939 38.6465Z",
    fill: "#F26283"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.565 49.2105C19.8568 49.1803 20.0545 49.4008 20.0075 49.7032C19.9809 49.8552 19.9092 49.9956 19.8017 50.1062C19.6942 50.2169 19.5558 50.2927 19.4047 50.3237C19.1177 50.3635 18.9224 50.1406 18.9622 49.8273C18.9853 49.6744 19.056 49.5325 19.1642 49.4219C19.2723 49.3112 19.4125 49.2372 19.565 49.2105Z",
    fill: "#065FE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9322 44.5105C12.2312 44.5262 12.4385 44.825 12.3988 45.1768C12.359 45.5286 12.0865 45.8093 11.7959 45.7997C11.5053 45.79 11.2871 45.4888 11.3245 45.1298C11.3619 44.7707 11.6331 44.4912 11.9322 44.5105Z",
    fill: "#9FB603"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.782 27.4803C25.9177 27.5363 26.0288 27.6391 26.0952 27.7699C26.1615 27.9008 26.1787 28.0511 26.1437 28.1936C26.127 28.2597 26.0964 28.3215 26.0539 28.3749C26.0115 28.4284 25.9582 28.4722 25.8976 28.5035C25.837 28.5348 25.7704 28.5529 25.7022 28.5566C25.6341 28.5603 25.5659 28.5495 25.5023 28.5249C25.3654 28.4708 25.253 28.3685 25.1864 28.2374C25.1198 28.1062 25.1035 27.9552 25.1406 27.8128C25.1572 27.7466 25.1876 27.6847 25.23 27.6311C25.2724 27.5775 25.3256 27.5336 25.3863 27.5021C25.4469 27.4707 25.5136 27.4525 25.5818 27.4487C25.65 27.445 25.7182 27.4557 25.782 27.4803Z",
    fill: "#9FB603"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2956 22.7744C10.6669 22.8948 10.8357 23.3551 10.6802 23.8081C10.5247 24.2611 10.0966 24.5419 9.71565 24.431C9.33465 24.3202 9.15862 23.8551 9.32139 23.3936C9.48416 22.9322 9.92423 22.6563 10.2956 22.7744Z",
    fill: "#F26283"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7398 17.2284C16.3749 16.5995 16.0228 15.9677 15.6836 15.3332C16.3925 15.1669 17.0918 15.0111 17.7815 14.8657C17.423 15.6513 17.0758 16.4388 16.7398 17.2284Z",
    fill: "#FDA014"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7852 33.5687C19.1919 32.9213 19.6006 32.2836 20.0113 31.6555C20.3055 32.3314 20.6069 32.9976 20.9144 33.6483C20.2079 33.6177 19.4981 33.5912 18.7852 33.5687Z",
    fill: "#FDA014"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3666 45.0335C6.71794 45.3773 6.07491 45.7259 5.4375 46.0793C5.51788 45.1829 5.61795 44.2918 5.73772 43.4058C6.28671 43.96 6.82967 44.5026 7.3666 45.0335Z",
    fill: "#065FE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.254883 41.1571C0.54907 41.0149 0.844464 40.8732 1.14106 40.7318C1.21823 40.3306 1.2978 39.9294 1.3822 39.5269C1.57672 39.8547 1.77164 40.182 1.96696 40.5089L2.91945 40.4378C2.7394 40.776 2.56257 41.1161 2.38895 41.4583C2.50871 41.8406 2.62928 42.2214 2.75065 42.6005C2.44803 42.4933 2.14781 42.3836 1.84036 42.274C1.60405 42.5407 1.37054 42.8081 1.13986 43.0764C1.11333 42.6595 1.08922 42.2439 1.06752 41.827C0.796638 41.6093 0.52576 41.386 0.254883 41.1571Z",
    fill: "#9FB603"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5352 35.5017C21.8293 35.3596 22.1251 35.2178 22.4225 35.0764C22.4985 34.6752 22.5793 34.274 22.6637 33.8716C22.8574 34.2009 23.0523 34.5282 23.2484 34.8535L24.2009 34.7836C24.0201 35.121 23.8392 35.462 23.6704 35.8029C23.7886 36.1845 23.9092 36.5656 24.0321 36.9463C23.7283 36.8379 23.4293 36.7295 23.1206 36.6186C22.8843 36.8853 22.6512 37.1532 22.4213 37.4222C22.394 37.0038 22.3699 36.5869 22.349 36.1716C22.0781 35.9491 21.8068 35.7258 21.5352 35.5017Z",
    fill: "#F26283"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6079 38.2327C41.5308 38.5784 40.688 38.6941 39.7319 38.4736C36.4042 37.6845 33.0464 36.7399 29.6523 35.6736C33.1922 36.1158 36.6453 36.6375 40.0104 37.2555C40.9701 37.4435 41.6839 37.8857 41.6079 38.2327Z",
    fill: "#F26283"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4546 31.3856C37.6306 31.8061 37.2545 32.0639 36.5986 32.0049C34.2034 31.794 31.7942 31.7964 29.3994 32.0121C31.7505 31.3109 33.9895 30.8494 36.0717 30.6747C36.6661 30.6241 37.2786 30.9639 37.4546 31.3856Z",
    fill: "#FDA014"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1668 22.0088C35.5815 22.7317 35.4622 23.4907 34.84 23.7944C32.6698 24.8655 30.1113 26.4559 27.3467 28.4932C29.5905 25.8583 31.6992 23.5763 33.5089 21.6678C34.0322 21.1148 34.7508 21.2943 35.1668 22.0088Z",
    fill: "#9FB603"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7291 48.7061C27.1818 49.0459 26.5946 48.8736 26.4029 48.276C25.7602 46.2073 25.0766 43.8711 24.4268 41.312C25.5136 43.3852 26.7431 45.3803 28.1065 47.2832C28.4465 47.7531 28.2741 48.3676 27.7291 48.7061Z",
    fill: "#FDC63A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5189 43.9251C38.9378 44.3625 37.7635 44.6408 36.9026 44.3842C33.9041 43.483 30.8742 41.5637 27.8672 38.9082C31.4686 40.9371 35.0748 42.3552 38.681 42.9312C39.7155 43.1047 40.0965 43.4854 39.5189 43.9251Z",
    fill: "#9FB603"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1629 36.1772C42.8085 36.0375 42.5456 35.7664 42.5722 35.5676C42.5987 35.3688 42.9001 35.3411 43.2473 35.5025C43.5946 35.664 43.8598 35.9387 43.8405 36.1146C43.8212 36.2905 43.5162 36.3194 43.1629 36.1772Z",
    fill: "#065FE5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8761 38.9455C31.4842 38.8998 31.2274 38.6046 31.3034 38.2865C31.3793 37.9684 31.7567 37.7636 32.1473 37.8275C32.538 37.8913 32.7924 38.1889 32.72 38.4841C32.6477 38.7793 32.2691 38.9901 31.8761 38.9455Z",
    fill: "#FDA014"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1405 24.9755C26.9626 24.8836 26.8217 24.7334 26.7413 24.55C26.661 24.3667 26.6461 24.1613 26.6992 23.9683C26.718 23.8813 26.7571 23.7999 26.8132 23.7307C26.8694 23.6616 26.941 23.6066 27.0224 23.5702C27.1037 23.5339 27.1925 23.5171 27.2815 23.5214C27.3705 23.5257 27.4573 23.5508 27.5347 23.5948C27.7076 23.6923 27.844 23.8436 27.923 24.0256C28.002 24.2076 28.0193 24.4105 27.9724 24.6033C27.9523 24.6891 27.9127 24.7692 27.8566 24.8372C27.8004 24.9052 27.7293 24.9594 27.6488 24.9954C27.5682 25.0315 27.4805 25.0484 27.3923 25.045C27.3041 25.0415 27.2179 25.0178 27.1405 24.9755Z",
    fill: "#FDC63A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.078 48.0246C22.9942 48.0421 22.9074 48.0378 22.8258 48.0121C22.7442 47.9864 22.6706 47.9402 22.612 47.8779C22.5534 47.8156 22.5118 47.7393 22.4912 47.6564C22.4706 47.5734 22.4717 47.4865 22.4944 47.4041C22.5393 47.2063 22.6446 47.0274 22.7959 46.8923C22.9471 46.7571 23.1368 46.6724 23.3384 46.6499C23.7351 46.6185 23.9967 46.8908 23.922 47.2655C23.8705 47.4604 23.7633 47.6361 23.6133 47.7709C23.4634 47.9058 23.2773 47.9939 23.078 48.0246Z",
    fill: "#9FB603"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2783 35.2861C39.0083 35.1922 38.8178 34.9693 38.8515 34.7873C38.8853 34.6054 39.1288 34.5464 39.3953 34.6476C39.6617 34.7488 39.8522 34.9753 39.8221 35.1464C39.792 35.3175 39.5484 35.3801 39.2783 35.2861Z",
    fill: "#FDA014"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2796 40.2691C41.9951 40.251 41.7973 40.1221 41.8371 39.9811C41.8769 39.8401 42.1361 39.7546 42.4171 39.7847C42.698 39.8148 42.8993 39.945 42.8608 40.0715C42.8222 40.198 42.563 40.2871 42.2796 40.2691Z",
    fill: "#9FB603"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4683 30.2428C30.3379 30.1937 30.2286 30.101 30.1589 29.9804C30.0892 29.8598 30.0635 29.7188 30.0861 29.5814C30.15 29.3211 30.4201 29.2055 30.689 29.3199C30.8175 29.3715 30.925 29.4647 30.9941 29.5847C31.0632 29.7047 31.0899 29.8444 31.07 29.9814C31.0109 30.2308 30.742 30.3477 30.4683 30.2428Z",
    fill: "#F26283"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2537 19.5507C29.1338 19.4592 29.044 19.3338 28.9961 19.1907C28.9482 19.0477 28.9443 18.8936 28.9849 18.7483C29.0729 18.4664 29.3309 18.3724 29.56 18.5411C29.6759 18.6359 29.7624 18.7616 29.8096 18.9037C29.8568 19.0457 29.8626 19.1982 29.8264 19.3435C29.8149 19.4037 29.7878 19.46 29.7479 19.5066C29.7081 19.5533 29.6568 19.5888 29.599 19.6097C29.5413 19.6306 29.4791 19.6362 29.4186 19.6258C29.3581 19.6155 29.3013 19.5896 29.2537 19.5507Z",
    fill: "#065FE5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1486 27.6653C34.9002 27.5159 34.735 27.2086 34.7869 26.9797C34.8387 26.7508 35.0678 26.6918 35.3126 26.8496C35.5573 27.0074 35.7213 27.3183 35.6803 27.5388C35.6393 27.7593 35.3982 27.8147 35.1486 27.6653Z",
    fill: "#9FB603"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3678 40.2064C22.2987 40.2006 22.2317 40.18 22.1713 40.146C22.111 40.112 22.0586 40.0654 22.0179 40.0094C21.9772 39.9534 21.949 39.8892 21.9353 39.8213C21.9216 39.7534 21.9227 39.6834 21.9385 39.616C21.9695 39.4696 22.0532 39.3397 22.1736 39.2509C22.2941 39.1621 22.4429 39.1205 22.592 39.134C22.6607 39.1401 22.7273 39.1607 22.7873 39.1946C22.8474 39.2285 22.8994 39.2749 22.94 39.3306C22.9806 39.3864 23.0087 39.4501 23.0225 39.5177C23.0363 39.5852 23.0355 39.6549 23.02 39.722C22.9864 39.8669 22.9023 39.9951 22.7828 40.0838C22.6634 40.1725 22.5163 40.2159 22.3678 40.2064Z",
    fill: "#9FB603"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2505 40.7415C37.8888 40.7282 37.6392 40.5343 37.7007 40.3102C37.7622 40.0861 38.1046 39.9282 38.4687 39.9608C38.8329 39.9933 39.0716 40.1837 39.0185 40.3897C38.9655 40.5957 38.6158 40.7535 38.2505 40.7415Z",
    fill: "#F26283"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2992 44.5878C33.8224 44.7548 34.3449 44.899 34.8666 45.0203C34.2034 45.3336 33.5399 45.6609 32.876 46.0022C33.0191 45.5324 33.1601 45.0609 33.2992 44.5878Z",
    fill: "#FDA014"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0539 34.1768C28.6914 34.6804 28.326 35.1949 27.9579 35.7202C27.6364 35.1579 27.3197 34.582 27.0078 33.9924C27.6926 34.0479 28.3747 34.1093 29.0539 34.1768Z",
    fill: "#FDA014"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9092 29.5603C39.4381 29.7033 39.9569 29.8639 40.4657 30.0422C40.395 30.4222 40.3182 30.8037 40.2354 31.1868C39.7853 30.6623 39.3432 30.1202 38.9092 29.5603Z",
    fill: "#065FE5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7073 34.6511C44.4814 34.5708 44.2535 34.4905 44.0236 34.4102C43.9802 34.5234 43.9368 34.6379 43.891 34.7536C43.7186 34.5536 43.545 34.3499 43.3726 34.1415C43.1194 34.017 42.865 33.8965 42.6094 33.78C42.7408 33.715 42.8698 33.6511 42.9952 33.5909C42.8867 33.3861 42.7782 33.1776 42.6697 32.9656C42.9108 33.1523 43.1604 33.3379 43.4075 33.5234C43.5872 33.5331 43.7692 33.5475 43.938 33.5668C43.9718 33.7282 44.0044 33.8909 44.0357 34.0487C44.2636 34.2487 44.483 34.4523 44.7073 34.6511Z",
    fill: "#9FB603"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5754 2.90318C60.7546 2.94655 61.5395 4.10802 61.3321 5.45623C60.622 10.1671 59.9492 14.8226 59.3645 19.4119C58.9159 14.8034 58.3698 10.1093 57.7669 5.33695C57.5921 3.96946 58.4011 2.8598 59.5754 2.90318Z",
    fill: "#F26283"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1676 10.8268C46.8428 10.4184 47.8556 10.7907 48.4174 11.6582C50.367 14.6703 52.2141 17.7402 53.8973 20.815C51.5285 18.0352 49.0135 15.3832 46.3629 12.8702C45.5889 12.1425 45.4912 11.2329 46.1676 10.8268Z",
    fill: "#FDA014"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8082 18.1249C33.1204 17.3044 34.6287 17.0105 36.1069 17.5551C41.2576 19.4503 46.0707 21.913 50.3967 24.5564C45.668 22.7612 40.5487 21.1744 35.1183 20.1069C33.5581 19.7973 32.4935 18.9478 32.8082 18.1249Z",
    fill: "#9FB603"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8788 20.0797C82.1103 20.7014 81.3049 21.346 80.1209 21.5677C76.1266 22.3222 72.1909 23.3594 68.3438 24.6714C71.8785 22.6888 75.5727 21.0046 79.3878 19.6364C80.5152 19.2364 81.6497 19.4605 81.8788 20.0797Z",
    fill: "#FDC63A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6353 6.00599C79.7987 6.84937 79.5733 8.22048 78.1855 9.16989C73.3568 12.5073 68.8029 16.5941 64.835 20.8978C67.7881 15.9654 71.0748 11.2403 74.6722 6.75539C75.6825 5.48429 77.4718 5.16983 78.6353 6.00599Z",
    fill: "#065FE5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3086 1.34782C51.3279 1.88518 50.8095 2.34422 50.1488 2.39241C49.4881 2.44061 48.9298 2.05626 48.8997 1.52372C48.8695 0.991186 49.3928 0.510455 50.062 0.459852C50.7311 0.409249 51.2893 0.81287 51.3086 1.34782Z",
    fill: "#065FE5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4964 15.8019C64.459 16.3152 63.9538 16.7019 63.3703 16.6718C62.7867 16.6417 62.3334 16.2043 62.3563 15.6886C62.3792 15.173 62.8808 14.7742 63.4788 14.8079C64.0768 14.8416 64.5326 15.2886 64.4964 15.8019Z",
    fill: "#FDA014"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4993 26.279C62.4631 26.791 61.958 27.1778 61.3756 27.1476C60.7933 27.1175 60.3363 26.6802 60.3592 26.1645C60.3821 25.6488 60.8849 25.25 61.4829 25.2838C62.0809 25.3175 62.5367 25.7657 62.4993 26.279Z",
    fill: "#FDA014"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3936 26.131C46.4199 26.242 46.4207 26.3576 46.3957 26.469C46.3708 26.5804 46.3208 26.6846 46.2496 26.7739C46.1784 26.8631 46.0878 26.935 45.9848 26.9842C45.8817 27.0333 45.7687 27.0584 45.6545 27.0575C45.4 27.0609 45.1514 26.98 44.9477 26.8275C44.744 26.6749 44.5966 26.4592 44.5284 26.2141C44.4079 25.7322 44.7442 25.3093 45.2687 25.2828C45.5256 25.2718 45.7783 25.3504 45.9835 25.5051C46.1887 25.6599 46.3337 25.8811 46.3936 26.131Z",
    fill: "#FDC63A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6824 25.4169C77.5257 25.87 76.9831 26.1953 76.4635 26.1507C75.9438 26.1061 75.6376 25.6953 75.775 25.2314C75.9125 24.7675 76.4502 24.4338 76.9807 24.4916C77.5112 24.5495 77.8331 24.9663 77.6824 25.4169Z",
    fill: "#9FB603"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1572 6.92038C53.1716 7.31436 52.7955 7.64328 52.3252 7.66256C51.855 7.68183 51.4523 7.38303 51.4342 6.99026C51.4161 6.59748 51.7851 6.25892 52.2637 6.23964C52.7424 6.22036 53.1427 6.52278 53.1572 6.92038Z",
    fill: "#FDA014"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2065 1.76346C66.1872 2.15503 65.7712 2.42733 65.2793 2.37672C64.7874 2.32612 64.4028 1.9719 64.4184 1.57671C64.4341 1.18152 64.8477 0.899592 65.3432 0.952605C65.8387 1.00562 66.2197 1.37189 66.2065 1.76346Z",
    fill: "#9FB603"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6372 20.0811C50.6733 20.4595 50.3695 20.7775 49.9572 20.7932C49.5448 20.8089 49.1711 20.5185 49.1264 20.1414C49.0818 19.7643 49.3833 19.4414 49.8065 19.4185C50.2297 19.3956 50.5986 19.7004 50.6372 20.0811Z",
    fill: "#F26283"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4312 25.947C38.5517 26.294 38.3371 26.5952 37.9489 26.6241C37.7559 26.6341 37.5642 26.586 37.3989 26.4859C37.2336 26.3857 37.1022 26.2383 37.0217 26.0626C36.8927 25.7241 37.1085 25.4205 37.504 25.3843C37.6981 25.3688 37.8922 25.4147 38.0587 25.5158C38.2251 25.6168 38.3555 25.7677 38.4312 25.947Z",
    fill: "#065FE5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0052 15.3295C42.0703 15.6982 41.7641 16.0355 41.3252 16.0861C40.8863 16.1367 40.4655 15.8861 40.3932 15.5223C40.3209 15.1584 40.6343 14.8162 41.078 14.7596C41.5217 14.703 41.9413 14.962 42.0052 15.3295Z",
    fill: "#9FB603"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6703 27.3852C66.6395 27.5657 66.5452 27.7292 66.4044 27.8463C66.2635 27.9634 66.0854 28.0263 65.9022 28.0238C65.817 28.022 65.733 28.0023 65.656 27.9657C65.5789 27.9292 65.5105 27.8768 65.4552 27.8118C65.4 27.7469 65.3591 27.671 65.3354 27.5892C65.3116 27.5073 65.3055 27.4214 65.3175 27.337C65.3438 27.1547 65.4364 26.9886 65.5777 26.8703C65.719 26.752 65.8989 26.69 66.0831 26.696C66.1692 26.696 66.2544 26.7146 66.3326 26.7507C66.4108 26.7868 66.4803 26.8394 66.5361 26.9049C66.592 26.9705 66.6329 27.0474 66.6561 27.1303C66.6792 27.2132 66.6841 27.3002 66.6703 27.3852Z",
    fill: "#9FB603"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M68.035 7.2069C67.9964 7.68884 67.4792 8.0274 66.8836 7.96716C66.288 7.90691 65.8238 7.46353 65.8539 6.97196C65.8841 6.48039 66.3965 6.12857 67.0066 6.19966C67.6166 6.27074 68.0736 6.72256 68.035 7.2069Z",
    fill: "#F26283"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6123 13.4844C77.2754 12.8627 77.9458 12.2558 78.6234 11.6638C79.0253 12.4807 79.4123 13.288 79.7845 14.0856C78.7283 13.8711 77.6709 13.6707 76.6123 13.4844Z",
    fill: "#FDA014"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2734 20.5864C58.1777 20.8989 59.0703 21.2166 59.9513 21.5395C59.2102 22.0873 58.4868 22.6407 57.781 23.1997C57.6163 22.3322 57.4471 21.4611 57.2734 20.5864Z",
    fill: "#FDA014"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0799 9.93344C39.4779 9.24106 38.8718 8.55831 38.2617 7.88521C39.3782 7.73501 40.493 7.60488 41.6063 7.49484C41.083 8.31172 40.5742 9.12459 40.0799 9.93344Z",
    fill: "#065FE5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7998 0.173828C43.0562 0.495118 43.3122 0.816409 43.5678 1.1377C44.079 1.11762 44.5899 1.10236 45.1003 1.09191C44.7538 1.42124 44.4094 1.75096 44.067 2.08109C44.1851 2.46101 44.3037 2.84094 44.4227 3.22086C43.9597 3.09636 43.4951 2.97588 43.0289 2.85941L41.7388 3.62087C41.7834 3.22207 41.8316 2.82206 41.8799 2.41603C41.4892 2.20278 41.0974 1.99554 40.7031 1.78952C41.2059 1.64012 41.7051 1.49313 42.2078 1.34975C42.4031 0.961792 42.6009 0.56781 42.7998 0.173828Z",
    fill: "#9FB603"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6929 24.4767C55.9497 24.7948 56.2077 25.114 56.4621 25.4406C56.9725 25.4205 57.4838 25.4052 57.9958 25.3948C57.6473 25.7237 57.3049 26.0538 56.9625 26.3839C57.0831 26.7635 57.2036 27.1442 57.317 27.5237C56.854 27.4032 56.3886 27.2828 55.9244 27.1623C55.4912 27.4145 55.0603 27.6683 54.6319 27.9237C54.6789 27.5237 54.7235 27.1237 54.7742 26.7189C54.3823 26.5056 53.9917 26.2972 53.5986 26.0936C54.0986 25.9434 54.5998 25.7968 55.1021 25.6538C55.2958 25.2626 55.4928 24.8703 55.6929 24.4767Z",
    fill: "#F26283"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0288 49.6801C57.5863 49.6801 57.2053 48.6897 57.2041 47.4644C57.227 43.1921 57.432 38.8378 57.7732 34.4064C58.2338 38.8402 58.5798 43.1921 58.7679 47.4596C58.8113 48.6825 58.4713 49.6765 58.0288 49.6801Z",
    fill: "#F26283"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2039 42.6931C64.7409 43.0268 64.3201 42.6413 64.208 41.8268C63.8294 38.987 63.1301 36.0592 62.168 33.0664C63.6847 35.7303 64.8784 38.3243 65.6801 40.8099C65.9104 41.522 65.6669 42.3593 65.2039 42.6931Z",
    fill: "#FDA014"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9826 37.2612C75.2266 37.9684 74.262 38.0395 73.7159 37.366C71.7976 35.0238 69.1343 32.3623 65.8789 29.5731C69.7226 31.5611 73.0986 33.4828 75.9355 35.1467C76.753 35.6286 76.7373 36.5587 75.9826 37.2612Z",
    fill: "#9FB603"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3446 35.742C40.7791 35.1721 40.8225 34.4082 41.4989 34.0142C43.8392 32.6479 46.4941 31.16 49.4287 29.6443C46.9607 31.7877 44.8568 33.8697 43.1869 35.789C42.7094 36.3456 41.9125 36.3107 41.3446 35.742Z",
    fill: "#FDC63A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4995 48.7417C49.8074 48.1585 49.1322 46.8079 49.2046 45.6886C49.4577 41.7837 50.942 37.5499 53.3316 33.1462C51.874 38.1017 51.1614 42.891 51.4785 47.4416C51.5556 48.7513 51.2 49.3212 50.4995 48.7417Z",
    fill: "#065FE5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9732 50.9923C61.0444 50.5212 61.3012 50.1248 61.5508 50.1008C61.8003 50.0767 61.9197 50.4369 61.8196 50.9044C61.7196 51.3719 61.4579 51.7731 61.2421 51.7984C61.0263 51.8237 60.9021 51.4622 60.9732 50.9923Z",
    fill: "#065FE5"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4131 38.0375C54.3576 37.5471 54.6458 37.1519 55.0533 37.1543C55.4608 37.1567 55.8189 37.5579 55.8527 38.0483C55.8864 38.5387 55.5983 38.9339 55.2137 38.9302C54.829 38.9266 54.4698 38.5266 54.4131 38.0375Z",
    fill: "#FDA014"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1021 28.3273C70.1649 28.0851 70.3086 27.8715 70.5094 27.7221C70.7103 27.5727 70.9562 27.4963 71.2065 27.5057C71.7117 27.5346 72.0227 27.9454 71.8973 28.4177C71.8268 28.6563 71.6801 28.8653 71.4796 29.0128C71.2791 29.1603 71.0359 29.2382 70.7869 29.2346C70.6774 29.2324 70.5699 29.2054 70.4724 29.1556C70.3749 29.1058 70.2899 29.0345 70.224 28.9472C70.1581 28.8598 70.1128 28.7586 70.0917 28.6513C70.0706 28.5439 70.0741 28.4331 70.1021 28.3273Z",
    fill: "#FDC63A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8671 29.8899C40.6983 29.4248 40.9648 29.0285 41.4579 29.0056C41.7125 29.0046 41.9611 29.083 42.169 29.2298C42.3769 29.3767 42.5338 29.5847 42.6178 29.8249C42.7661 30.2984 42.5057 30.6947 42.0318 30.7092C41.7789 30.7009 41.534 30.6189 41.327 30.4734C41.1201 30.3278 40.9603 30.125 40.8671 29.8899Z",
    fill: "#9FB603"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9587 46.0138C60.9973 45.6596 61.2155 45.3644 61.447 45.3547C61.6785 45.3451 61.8244 45.6222 61.7726 45.9764C61.7207 46.3307 61.5013 46.6258 61.2831 46.6367C61.0648 46.6475 60.9226 46.3692 60.9587 46.0138Z",
    fill: "#FDA014"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7395 51.0701C55.6828 50.7183 55.7829 50.4412 55.9649 50.4496C56.147 50.4581 56.3266 50.7508 56.3676 51.1014C56.4086 51.452 56.3098 51.7304 56.1434 51.7219C55.977 51.7135 55.7973 51.4207 55.7395 51.0701Z",
    fill: "#9FB603"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6248 33.8662C64.6463 33.693 64.728 33.5329 64.8556 33.4137C64.9831 33.2946 65.1485 33.224 65.3229 33.2144C65.6569 33.2144 65.8751 33.5144 65.8124 33.8734C65.7497 34.2324 65.435 34.5252 65.1131 34.524C64.7912 34.5228 64.573 34.2288 64.6248 33.8662Z",
    fill: "#F26283"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3126 29.372C77.3905 29.2005 77.5181 29.0562 77.6788 28.9579C77.8396 28.8595 78.0261 28.8116 78.2145 28.8202C78.5834 28.8479 78.7703 29.1347 78.6304 29.4612C78.5471 29.6289 78.418 29.7697 78.2579 29.8671C78.0979 29.9645 77.9135 30.0147 77.7261 30.0118C77.368 29.9901 77.1788 29.7046 77.3126 29.372Z",
    fill: "#065FE5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M69.084 38.8338C69.1949 38.4892 69.5228 38.2013 69.8146 38.1928C70.1064 38.1844 70.2462 38.4543 70.1221 38.7952C69.9979 39.1362 69.6675 39.4242 69.3866 39.4374C69.1057 39.4507 68.9779 39.1796 69.084 38.8338Z",
    fill: "#9FB603"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1977 26.8174C50.1852 26.7313 50.1914 26.6436 50.216 26.5602C50.2407 26.4767 50.2831 26.3996 50.3404 26.3342C50.3976 26.2687 50.4684 26.2164 50.5479 26.1808C50.6273 26.1453 50.7135 26.1273 50.8005 26.1282C50.9871 26.1256 51.1683 26.1913 51.3097 26.313C51.4512 26.4346 51.5433 26.6037 51.5686 26.7885C51.5806 26.8739 51.5742 26.9609 51.5498 27.0436C51.5253 27.1262 51.4834 27.2027 51.4268 27.2678C51.3702 27.3329 51.3003 27.3852 51.2218 27.4209C51.1433 27.4567 51.058 27.4752 50.9717 27.4753C50.7855 27.4756 50.6052 27.4096 50.4633 27.289C50.3214 27.1684 50.2273 27.0012 50.1977 26.8174Z",
    fill: "#9FB603"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0274 46.299C53.9394 45.8508 54.1069 45.4978 54.3963 45.5098C54.6857 45.5219 54.9763 45.8942 55.0402 46.3448C55.1041 46.7954 54.9401 47.1484 54.6712 47.1364C54.4023 47.1243 54.1106 46.7484 54.0274 46.299Z",
    fill: "#F26283"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9384 41.3586C47.8814 42.0421 47.8528 42.7176 47.8528 43.3851C47.2838 42.6622 46.6974 41.9465 46.0938 41.2381C46.7074 41.2826 47.3235 41.3224 47.9384 41.3586Z",
    fill: "#FDA014"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M59.429 33.2532C58.7112 32.9544 57.981 32.6548 57.2383 32.3544C57.8291 31.8058 58.4416 31.258 59.0757 30.711C59.2011 31.5576 59.3189 32.405 59.429 33.2532Z",
    fill: "#FDA014"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8373 43.9477C67.8124 44.6321 67.7605 45.3096 67.6818 45.9803C67.1995 46.0008 66.7172 46.014 66.2217 46.0212C66.7401 45.3285 67.2791 44.6321 67.8373 43.9477Z",
    fill: "#065FE5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2676 52.4401C63.3061 52.1401 63.3411 51.8377 63.37 51.5401L62.9131 51.4738C63.1084 51.2075 63.3085 50.9389 63.5159 50.6714C63.5955 50.328 63.6715 49.9834 63.7462 49.6388C63.8644 49.7802 63.9777 49.9188 64.0862 50.0545C64.3048 49.8641 64.5279 49.6734 64.7554 49.4822C64.5986 49.834 64.4407 50.1858 64.2852 50.5376C64.3225 50.7581 64.3563 50.9786 64.3816 51.1955L63.821 51.4509C63.6317 51.781 63.446 52.1112 63.2676 52.4401Z",
    fill: "#9FB603"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M35.582 57.1993C35.3662 60.1162 32.3508 58.6451 32.3508 58.6451H32.1759C32.1759 58.6451 33.2611 64.4018 32.6582 65.5729C32.0554 66.744 30.0057 66.4007 28.999 66.391C27.9922 66.3814 28.155 64.0163 28.155 64.0163C27.9814 64.1368 27.6486 64.1572 27.3194 64.1368C26.9891 64.1548 26.6575 64.1368 26.4839 64.0163C26.4839 64.0163 26.6467 66.3802 25.6399 66.391C24.6332 66.4019 22.5751 66.7428 21.9807 65.5729C21.3863 64.403 22.4629 58.6451 22.4629 58.6451H22.2881C22.2881 58.6451 19.2739 60.121 19.0557 57.1993C19.0557 57.1993 20.5025 50.3546 25.6158 53.0932C25.6158 53.0932 26.3392 53.2571 27.317 53.3727C28.296 53.2523 29.017 53.0932 29.017 53.0932C34.1436 50.3546 35.582 57.1993 35.582 57.1993Z",
    fill: "#00AFB9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M35.582 57.1993C35.3662 60.1162 32.3508 58.6451 32.3508 58.6451H32.1759C32.1759 58.6451 33.2611 64.4018 32.6582 65.5729C32.0554 66.744 30.0057 66.4007 28.999 66.391C27.9922 66.3814 28.155 64.0163 28.155 64.0163C27.9814 64.1368 27.6486 64.1572 27.3194 64.1368C26.9891 64.1548 26.6575 64.1368 26.4839 64.0163C26.4839 64.0163 26.6467 66.3802 25.6399 66.391C24.6332 66.4019 22.5751 66.7428 21.9807 65.5729C21.3863 64.403 22.4629 58.6451 22.4629 58.6451H22.2881C22.2881 58.6451 19.2739 60.121 19.0557 57.1993C19.0557 57.1993 20.5025 50.3546 25.6158 53.0932C25.6158 53.0932 26.3392 53.2571 27.317 53.3727C28.296 53.2523 29.017 53.0932 29.017 53.0932C34.1436 50.3546 35.582 57.1993 35.582 57.1993Z",
    fill: "#023854"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8901 55.7322C19.8901 55.7322 19.2619 57.6756 20.9752 58.6997C20.9776 58.6997 18.6133 58.2876 19.8901 55.7322Z",
    fill: "url(#paint0_linear)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8156 55.7791C34.8156 55.7791 35.445 57.7225 33.7305 58.7454C33.7293 58.7454 36.0936 58.3333 34.8156 55.7791Z",
    fill: "url(#paint1_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3045 63.7046C22.3045 63.7046 21.8367 65.5118 24.324 66.0817C24.324 66.0781 21.4725 66.4058 22.3045 63.7046Z",
    fill: "url(#paint2_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3191 63.7061C32.3191 63.7061 32.7881 65.5133 30.3008 66.0832C30.3008 66.0784 33.1486 66.4073 32.3191 63.7061Z",
    fill: "url(#paint3_linear)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M36.496 47.956C36.4184 48.205 36.3241 48.4485 36.2139 48.6849C36.2561 48.5897 36.3634 48.3343 36.496 47.956Z",
    fill: "url(#paint4_linear)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8851 45.8585C36.8851 47.6964 36.3397 49.4931 35.3178 51.0213C34.296 52.5496 32.8436 53.7407 31.1443 54.444C29.4451 55.1474 27.5753 55.3314 25.7714 54.9728C23.9674 54.6143 22.3104 53.7292 21.0099 52.4296C19.7093 51.1299 18.8236 49.4741 18.4648 47.6714C18.106 45.8688 18.2902 44.0003 18.994 42.3022C19.6979 40.6042 20.8898 39.1528 22.4191 38.1317C23.9484 37.1106 25.7463 36.5656 27.5856 36.5656C30.052 36.5656 32.4173 37.5446 34.1613 39.2874C35.9053 41.0301 36.8851 43.3938 36.8851 45.8585Z",
    fill: "#00AFB9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M36.8851 45.8585C36.8851 47.6964 36.3397 49.4931 35.3178 51.0213C34.296 52.5496 32.8436 53.7407 31.1443 54.444C29.4451 55.1474 27.5753 55.3314 25.7714 54.9728C23.9674 54.6143 22.3104 53.7292 21.0099 52.4296C19.7093 51.1299 18.8236 49.4741 18.4648 47.6714C18.106 45.8688 18.2902 44.0003 18.994 42.3022C19.6979 40.6042 20.8898 39.1528 22.4191 38.1317C23.9484 37.1106 25.7463 36.5656 27.5856 36.5656C30.052 36.5656 32.4173 37.5446 34.1613 39.2874C35.9053 41.0301 36.8851 43.3938 36.8851 45.8585Z",
    fill: "#002833"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.076 38.2207C29.9103 39.787 28.5298 42.1545 25.9906 43.5027C23.4514 44.8509 20.7181 44.6726 19.8838 43.1039C19.0495 41.5352 20.4312 39.1701 22.9692 37.8219C25.5071 36.4737 28.2416 36.652 29.076 38.2207Z",
    fill: "url(#paint5_linear)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9648 37.6039C30.9648 37.6039 35.0027 38.4678 36.0118 44.916C36.0118 44.916 34.4625 38.9364 30.9648 37.6039Z",
    fill: "url(#paint6_linear)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9141 54.1012C28.9141 54.1012 33.404 53.8386 34.7978 48.0854C34.7978 48.0854 35.0064 53.5241 28.9141 54.1012Z",
    fill: "url(#paint7_linear)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1973 49.2491C27.3452 49.2491 27.465 49.1293 27.465 48.9816C27.465 48.8339 27.3452 48.7141 27.1973 48.7141C27.0495 48.7141 26.9297 48.8339 26.9297 48.9816C26.9297 49.1293 27.0495 49.2491 27.1973 49.2491Z",
    fill: "#DFF1F5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M27.465 48.8379C27.465 48.8908 27.4493 48.9426 27.4199 48.9865C27.3905 49.0305 27.3487 49.0648 27.2998 49.0851C27.2509 49.1053 27.1971 49.1106 27.1451 49.1003C27.0932 49.09 27.0455 49.0645 27.0081 49.0271C26.9707 48.9897 26.9452 48.942 26.9348 48.8901C26.9245 48.8382 26.9298 48.7845 26.9501 48.7356C26.9703 48.6867 27.0046 48.6449 27.0486 48.6155C27.0927 48.5862 27.1444 48.5705 27.1974 48.5705C27.2325 48.5705 27.2673 48.5774 27.2998 48.5908C27.3323 48.6043 27.3618 48.624 27.3866 48.6488C27.4115 48.6736 27.4312 48.7031 27.4446 48.7356C27.4581 48.768 27.465 48.8028 27.465 48.8379Z",
    fill: "#077CA0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1973 49.1765C27.3452 49.1765 27.465 49.0568 27.465 48.909C27.465 48.7613 27.3452 48.6416 27.1973 48.6416C27.0495 48.6416 26.9297 48.7613 26.9297 48.909C26.9297 49.0568 27.0495 49.1765 27.1973 49.1765Z",
    fill: "#237F92"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9913 49.2491C28.1391 49.2491 28.259 49.1293 28.259 48.9816C28.259 48.8339 28.1391 48.7141 27.9913 48.7141C27.8435 48.7141 27.7236 48.8339 27.7236 48.9816C27.7236 49.1293 27.8435 49.2491 27.9913 49.2491Z",
    fill: "#DFF1F5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28.259 48.8379C28.259 48.8908 28.2433 48.9426 28.2139 48.9865C28.1844 49.0305 28.1426 49.0648 28.0937 49.0851C28.0448 49.1053 27.991 49.1106 27.9391 49.1003C27.8872 49.09 27.8395 49.0645 27.802 49.0271C27.7646 48.9897 27.7391 48.942 27.7288 48.8901C27.7184 48.8382 27.7237 48.7845 27.744 48.7356C27.7643 48.6867 27.7986 48.6449 27.8426 48.6155C27.8866 48.5862 27.9384 48.5705 27.9913 48.5705C28.0622 48.5708 28.1301 48.5991 28.1802 48.6492C28.2303 48.6993 28.2586 48.7671 28.259 48.8379Z",
    fill: "#077CA0"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9913 49.1765C28.1391 49.1765 28.259 49.0568 28.259 48.909C28.259 48.7613 28.1391 48.6416 27.9913 48.6416C27.8435 48.6416 27.7236 48.7613 27.7236 48.909C27.7236 49.0568 27.8435 49.1765 27.9913 49.1765Z",
    fill: "#237F92"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M24.707 50.3339C24.7297 51.0855 25.0473 51.798 25.5912 52.3176C26.1351 52.8372 26.8616 53.1222 27.6139 53.1111C29.2103 53.1111 30.4003 51.8701 30.4702 50.293L24.707 50.3339Z",
    fill: "#967133"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6484 50.512C24.6793 51.2777 25.0055 52.0018 25.5585 52.5326C26.1116 53.0635 26.8488 53.3599 27.6156 53.3599C28.3825 53.3599 29.1196 53.0635 29.6727 52.5326C30.2258 52.0018 30.5519 51.2777 30.5828 50.512H24.6484Z",
    fill: "#FFF0D9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6484 50.394C24.6793 51.1598 25.0055 51.8838 25.5585 52.4147C26.1116 52.9455 26.8488 53.242 27.6156 53.242C28.3825 53.242 29.1196 52.9455 29.6727 52.4147C30.2258 51.8838 30.5519 51.1598 30.5828 50.394H24.6484Z",
    fill: "url(#paint8_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M25.5589 50.2802C25.5517 50.5216 25.4503 50.7506 25.2764 50.9183C25.1025 51.086 24.8698 51.1792 24.6281 51.1778C24.5095 51.1781 24.3921 51.1548 24.2826 51.1093C24.1731 51.0637 24.0738 50.9968 23.9905 50.9124C23.9072 50.8281 23.8416 50.728 23.7975 50.6179C23.7533 50.5079 23.7316 50.3902 23.7335 50.2718C23.7398 50.0302 23.8408 49.8009 24.0146 49.633C24.1885 49.4651 24.4213 49.3722 24.6631 49.3741C24.7817 49.3741 24.899 49.3976 25.0084 49.4433C25.1178 49.489 25.2171 49.5559 25.3004 49.6402C25.3837 49.7244 25.4495 49.8244 25.4939 49.9343C25.5382 50.0441 25.5604 50.1617 25.5589 50.2802Z",
    fill: "url(#paint9_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M28.9152 53.4757C28.9056 53.9877 28.2557 54.3986 27.4684 54.3914C26.6811 54.3841 26.0469 53.9648 26.0578 53.4528C26.0686 52.9407 26.7161 52.5287 27.5046 52.5347C28.2931 52.5407 28.9249 52.9624 28.9152 53.4757Z",
    fill: "url(#paint10_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M29.4074 53.3079C29.3978 53.8199 28.7479 54.2308 27.9606 54.2235C27.1733 54.2163 26.5391 53.797 26.5499 53.2838C26.5608 52.7705 27.2082 52.3609 27.9968 52.3669C28.7853 52.3729 29.4171 52.7898 29.4074 53.3079Z",
    fill: "url(#paint11_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M31.409 50.3663C31.4018 50.6066 31.3007 50.8346 31.1275 51.0015C30.9542 51.1683 30.7225 51.2608 30.4819 51.2591C30.3632 51.2594 30.2457 51.2361 30.1361 51.1906C30.0266 51.145 29.9272 51.0781 29.8438 50.9938C29.7604 50.9094 29.6947 50.8093 29.6504 50.6993C29.6062 50.5893 29.5843 50.4716 29.586 50.353C29.5917 50.1119 29.6922 49.8826 29.8657 49.7149C30.0392 49.5471 30.2718 49.4544 30.5132 49.4566C30.6323 49.4558 30.7504 49.4789 30.8604 49.5245C30.9704 49.5701 31.0701 49.6373 31.1537 49.7221C31.2372 49.8069 31.3029 49.9077 31.3467 50.0183C31.3906 50.129 31.4118 50.2473 31.409 50.3663Z",
    fill: "url(#paint12_radial)"
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7311 50.2868C24.6352 50.5122 24.6165 50.7629 24.678 51C24.5635 50.8735 24.5575 50.5759 24.678 50.2711C24.7986 49.9663 24.9831 49.7639 25.147 49.7325C24.9548 49.8703 24.8095 50.0638 24.7311 50.2868Z",
    fill: "#077CA0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6896 50.2729C24.5925 50.5026 24.5839 50.7601 24.6655 50.9958C24.5292 50.8608 24.5063 50.5572 24.6233 50.2524C24.7402 49.9476 24.944 49.7512 25.1297 49.7283C24.9233 49.8523 24.7674 50.0452 24.6896 50.2729Z",
    fill: "#077CA0"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5537 50.2868C30.6495 50.5122 30.6682 50.7629 30.6067 51C30.7273 50.8735 30.7273 50.5759 30.6067 50.2711C30.4861 49.9663 30.3017 49.7639 30.1377 49.7325C30.33 49.8703 30.4752 50.0638 30.5537 50.2868Z",
    fill: "#077CA0"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5914 50.2729C30.6885 50.5026 30.6971 50.7601 30.6156 50.9958C30.7518 50.8608 30.7747 50.5572 30.6578 50.2524C30.5408 49.9476 30.3382 49.7512 30.1514 49.7283C30.3577 49.8523 30.5136 50.0452 30.5914 50.2729Z",
    fill: "#077CA0"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0739 45.2551C36.0736 46.0211 35.8461 46.7699 35.42 47.4068C34.9939 48.0436 34.3884 48.5399 33.6801 48.8329C32.9718 49.1259 32.1925 49.2024 31.4406 49.0528C30.6888 48.9032 29.9982 48.5342 29.4562 47.9925C28.9142 47.4507 28.5452 46.7605 28.3957 46.0091C28.2462 45.2578 28.323 44.479 28.6165 43.7712C28.9099 43.0635 29.4067 42.4586 30.0442 42.033C30.6816 41.6075 31.431 41.3803 32.1976 41.3803C33.2257 41.3806 34.2117 41.789 34.9386 42.5156C35.6655 43.2422 36.0739 44.2276 36.0739 45.2551Z",
    fill: "#077CA0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0739 45.8826C36.0739 46.6487 35.8465 47.3976 35.4206 48.0346C34.9947 48.6716 34.3893 49.1681 33.681 49.4613C32.9727 49.7544 32.1933 49.8311 31.4413 49.6817C30.6894 49.5322 29.9987 49.1633 29.4566 48.6216C28.9145 48.0799 28.5453 47.3896 28.3958 46.6383C28.2462 45.8869 28.323 45.108 28.6164 44.4002C28.9097 43.6924 29.4066 43.0874 30.044 42.6618C30.6815 42.2362 31.4309 42.009 32.1976 42.009C33.2256 42.009 34.2116 42.4171 34.9385 43.1435C35.6655 43.87 36.0739 44.8552 36.0739 45.8826Z",
    fill: "#DFF1F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0739 45.5682C36.0739 46.3343 35.8465 47.0832 35.4206 47.7202C34.9947 48.3572 34.3893 48.8537 33.681 49.1469C32.9727 49.4401 32.1933 49.5168 31.4413 49.3673C30.6894 49.2179 29.9987 48.8489 29.4566 48.3072C28.9145 47.7655 28.5453 47.0753 28.3958 46.3239C28.2462 45.5725 28.323 44.7937 28.6164 44.0859C28.9097 43.3781 29.4066 42.7731 30.044 42.3475C30.6815 41.9218 31.4309 41.6946 32.1976 41.6946C33.2256 41.6946 34.2116 42.1027 34.9385 42.8292C35.6655 43.5556 36.0739 44.5409 36.0739 45.5682Z",
    fill: "url(#paint13_radial)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5983 45.4982C34.5985 45.9658 34.46 46.423 34.2001 46.8119C33.9403 47.2009 33.5709 47.504 33.1386 47.6831C32.7063 47.8622 32.2305 47.9091 31.7715 47.8179C31.3126 47.7267 30.8909 47.5016 30.56 47.1709C30.2291 46.8402 30.0038 46.4189 29.9126 45.9603C29.8213 45.5016 29.8683 45.0262 30.0475 44.5942C30.2267 44.1622 30.5301 43.793 30.9193 43.5334C31.3085 43.2737 31.766 43.1353 32.234 43.1355C32.5444 43.1355 32.8519 43.1966 33.1387 43.3153C33.4256 43.4341 33.6863 43.6081 33.9058 43.8275C34.1254 44.0469 34.2995 44.3074 34.4183 44.594C34.5371 44.8807 34.5983 45.1879 34.5983 45.4982Z",
    fill: "url(#paint14_radial)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4234 45.5672C33.4237 45.8144 33.3505 46.0561 33.2132 46.2618C33.0759 46.4674 32.8807 46.6278 32.6522 46.7225C32.4237 46.8172 32.1722 46.842 31.9295 46.7939C31.6869 46.7457 31.464 46.6267 31.2891 46.4519C31.1141 46.277 30.995 46.0543 30.9468 45.8118C30.8986 45.5694 30.9235 45.318 31.0183 45.0897C31.113 44.8613 31.2735 44.6662 31.4793 44.529C31.6851 44.3918 31.927 44.3187 32.1744 44.319C32.5056 44.319 32.8233 44.4505 33.0576 44.6846C33.2918 44.9186 33.4234 45.2361 33.4234 45.5672Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5607 44.6638C33.5604 44.775 33.5272 44.8837 33.4652 44.9761C33.4032 45.0684 33.3152 45.1404 33.2123 45.1828C33.1094 45.2252 32.9962 45.2361 32.887 45.2143C32.7779 45.1924 32.6777 45.1388 32.5991 45.06C32.5204 44.9813 32.4669 44.881 32.4453 44.7719C32.4237 44.6628 32.4349 44.5497 32.4775 44.447C32.5202 44.3442 32.5924 44.2564 32.6849 44.1947C32.7775 44.1329 32.8863 44.0999 32.9976 44.0999C33.0717 44.0999 33.145 44.1145 33.2134 44.1429C33.2818 44.1712 33.3439 44.2128 33.3962 44.2651C33.4485 44.3175 33.4899 44.3797 33.5182 44.4481C33.5464 44.5165 33.5608 44.5898 33.5607 44.6638Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7191 45.6521C33.7194 45.7112 33.702 45.7691 33.6693 45.8184C33.6366 45.8677 33.59 45.9062 33.5354 45.929C33.4807 45.9518 33.4206 45.9579 33.3625 45.9465C33.3044 45.9351 33.251 45.9068 33.2091 45.865C33.1672 45.8233 33.1386 45.77 33.1269 45.712C33.1153 45.654 33.1211 45.5939 33.1437 45.5392C33.1663 45.4846 33.2047 45.4378 33.2539 45.4049C33.3031 45.3721 33.3609 45.3545 33.4201 45.3545C33.4593 45.3543 33.4982 45.3619 33.5344 45.3768C33.5707 45.3917 33.6037 45.4136 33.6315 45.4412C33.6592 45.4689 33.6813 45.5017 33.6963 45.5379C33.7114 45.5741 33.7191 45.6129 33.7191 45.6521Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6315 45.2551C26.6312 46.0212 26.4037 46.77 25.9776 47.4068C25.5515 48.0437 24.9461 48.54 24.2377 48.833C23.5294 49.126 22.7501 49.2025 21.9982 49.0529C21.2464 48.9033 20.5558 48.5343 20.0138 47.9925C19.4718 47.4507 19.1028 46.7605 18.9533 46.0092C18.8038 45.2578 18.8807 44.479 19.1741 43.7713C19.4675 43.0636 19.9643 42.4587 20.6018 42.0331C21.2392 41.6075 21.9886 41.3804 22.7552 41.3804C23.7834 41.3807 24.7693 41.7891 25.4962 42.5157C26.2231 43.2423 26.6315 44.2277 26.6315 45.2551Z",
    fill: "#077CA0"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6315 45.8826C26.6315 46.6487 26.4041 47.3976 25.9782 48.0346C25.5523 48.6716 24.9469 49.1681 24.2386 49.4613C23.5303 49.7545 22.7509 49.8312 21.999 49.6817C21.247 49.5323 20.5564 49.1633 20.0142 48.6216C19.4721 48.0799 19.103 47.3897 18.9534 46.6383C18.8038 45.8869 18.8806 45.108 19.174 44.4002C19.4674 43.6924 19.9642 43.0875 20.6016 42.6618C21.2391 42.2362 21.9885 42.009 22.7552 42.009C23.7832 42.009 24.7692 42.4171 25.4961 43.1436C26.2231 43.87 26.6315 44.8553 26.6315 45.8826Z",
    fill: "#DFF1F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6315 45.5681C26.6315 46.3343 26.4041 47.0832 25.9782 47.7202C25.5523 48.3572 24.9469 48.8537 24.2386 49.1468C23.5303 49.44 22.7509 49.5167 21.999 49.3673C21.247 49.2178 20.5564 48.8489 20.0142 48.3072C19.4721 47.7654 19.103 47.0752 18.9534 46.3238C18.8038 45.5724 18.8806 44.7936 19.174 44.0858C19.4674 43.378 19.9642 42.773 20.6016 42.3474C21.2391 41.9218 21.9885 41.6946 22.7552 41.6946C23.7832 41.6946 24.7692 42.1027 25.4961 42.8291C26.2231 43.5556 26.6315 44.5408 26.6315 45.5681Z",
    fill: "url(#paint15_radial)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M25.152 45.4982C25.1523 45.9658 25.0137 46.423 24.7538 46.812C24.494 47.2009 24.1246 47.5041 23.6923 47.6831C23.26 47.8622 22.7842 47.9091 22.3253 47.8179C21.8663 47.7268 21.4447 47.5016 21.1138 47.1709C20.7829 46.8403 20.5575 46.419 20.4663 45.9603C20.3751 45.5016 20.422 45.0262 20.6012 44.5942C20.7804 44.1622 21.0838 43.7931 21.473 43.5334C21.8622 43.2738 22.3197 43.1353 22.7877 43.1355C23.4147 43.1355 24.0161 43.3845 24.4595 43.8275C24.9029 44.2706 25.152 44.8716 25.152 45.4982Z",
    fill: "url(#paint16_radial)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9772 45.5671C23.9774 45.8143 23.9042 46.056 23.767 46.2616C23.6297 46.4673 23.4344 46.6276 23.2059 46.7223C22.9774 46.8171 22.7259 46.8419 22.4832 46.7937C22.2406 46.7456 22.0177 46.6265 21.8428 46.4517C21.6678 46.2769 21.5487 46.0542 21.5005 45.8117C21.4523 45.5692 21.4772 45.3179 21.572 45.0896C21.6667 44.8612 21.8272 44.6661 22.033 44.5289C22.2388 44.3917 22.4807 44.3186 22.7281 44.3188C23.0593 44.3188 23.3771 44.4504 23.6113 44.6844C23.8456 44.9185 23.9772 45.236 23.9772 45.5671Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1168 44.6638C24.1168 44.7753 24.0837 44.8843 24.0217 44.9771C23.9597 45.0698 23.8716 45.1421 23.7685 45.1847C23.6654 45.2274 23.5519 45.2386 23.4425 45.2168C23.333 45.1951 23.2325 45.1414 23.1536 45.0625C23.0746 44.9836 23.0209 44.8832 22.9991 44.7738C22.9774 44.6644 22.9885 44.551 23.0312 44.448C23.0739 44.345 23.1463 44.2569 23.2391 44.1949C23.3318 44.133 23.4409 44.0999 23.5525 44.0999C23.7022 44.0999 23.8457 44.1593 23.9515 44.2651C24.0574 44.3708 24.1168 44.5142 24.1168 44.6638Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2777 45.6521C24.2779 45.7112 24.2606 45.7691 24.2279 45.8184C24.1952 45.8677 24.1486 45.9062 24.094 45.929C24.0393 45.9518 23.9792 45.9579 23.9211 45.9465C23.863 45.9351 23.8096 45.9068 23.7677 45.865C23.7258 45.8233 23.6972 45.77 23.6855 45.712C23.6739 45.654 23.6797 45.5939 23.7023 45.5392C23.7249 45.4846 23.7633 45.4378 23.8124 45.4049C23.8616 45.3721 23.9195 45.3545 23.9787 45.3545C24.0179 45.3543 24.0568 45.3619 24.093 45.3768C24.1293 45.3917 24.1623 45.4136 24.1901 45.4412C24.2178 45.4689 24.2399 45.5017 24.2549 45.5379C24.27 45.5741 24.2777 45.6129 24.2777 45.6521Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4951 48.6096C37.3089 46.0047 35.938 43.8866 34.6046 42.5444C33.1577 43.6288 30.5342 45.4878 28.8173 46.1348C28.8173 46.1348 30.4896 44.4818 31.9593 42.701C30.4486 43.5384 28.3 44.3758 25.8006 44.3264L27.2221 42.6191L24.2019 44.4264C24.2019 44.4264 24.9434 42.354 24.9663 42.2878C24.3791 43.3649 22.7961 45.3276 21.2058 45.7818C21.5205 45.5131 21.5072 42.7998 21.3577 43.0974C21.2082 43.395 19.0283 44.8493 19.0669 45.3939C19.0033 45.3404 18.9437 45.2824 18.8884 45.2204C18.3808 46.3625 18.2458 47.7505 18.9632 49.3517C18.6533 48.6674 16.9642 44.5866 18.786 41.0685C18.997 40.4504 20.9863 34.3949 30.1194 35.619C32.9853 36.0033 34.6287 38.1817 34.742 38.3552C37.7188 41.695 37.1666 46.6818 36.4951 48.6096Z",
    fill: "url(#paint17_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.9133 38.2307L26.4365 38.0632C26.0881 38.7861 26.316 39.3488 26.316 39.3488L26.8392 38.9572C26.8392 40.0199 27.5385 40.4669 27.5385 40.4669L27.5964 39.6837C28.1209 40.5271 29.3434 40.691 29.3434 40.691L29.2229 39.8476C29.98 40.691 30.853 40.691 30.853 40.691L30.6203 39.8476C32.1876 41.0211 33.7068 40.7982 33.7068 40.7982C33.0075 40.5741 32.4252 39.6789 32.4252 39.6789C33.7755 40.2946 35.3429 40.0199 35.3429 40.0199C34.7027 39.8524 34.2373 39.0692 34.2373 39.0692L33.7755 38.5379L34.0673 39.5717C33.397 39.8235 31.7379 39.2102 31.7379 39.2102L32.2612 39.909C31.4751 40.0765 30.3393 39.1548 30.3393 39.1548L30.4273 40.0211C29.8739 40.0488 28.913 39.0427 28.913 39.0427L29.0589 40.0488C28.7092 39.9367 27.5156 39.1825 27.5156 39.1825L27.4276 39.8813C27.137 39.6018 27.0792 38.3439 27.0792 38.3439L26.6126 38.903C26.6126 38.49 26.653 38.078 26.7331 37.6728L26.2376 37.8969L26.2087 37.4487L25.9133 38.2307ZM21.7344 40.1584C21.7344 40.1584 21.3051 41.009 20.8904 41.1873C20.8904 41.1873 21.6885 41.5054 22.6989 40.4391L22.4674 41.2584C22.4674 41.2584 22.9437 41.3139 23.4621 40.5355L23.2933 41.3608C23.2933 41.3608 23.9817 41.2717 24.3784 40.4729L24.3121 41.2536C24.3121 41.2536 24.7498 40.8536 24.8824 39.7994L25.1235 40.2211C25.2485 39.8037 25.2798 39.3639 25.2152 38.9331L25.4792 39.1331L25.4189 38.3379L25.3466 38.7801L25.1054 38.5271C25.0971 38.9377 25.0665 39.3475 25.0138 39.7548L24.8293 39.1704C24.8293 39.1704 24.6401 40.415 24.4471 40.6741L24.4869 39.9753C24.4869 39.9753 23.7406 40.6488 23.5356 40.7367L23.7406 39.7476C23.7406 39.7476 23.0907 40.6849 22.7917 40.6223L22.9485 39.768C22.9485 39.768 22.213 40.6114 21.8043 40.3958L22.178 39.7355C22.178 39.7355 21.1954 40.2403 20.8614 39.9476L21.1496 38.9391L20.8289 39.4379C20.8289 39.4379 20.4768 40.1849 20.1055 40.3102C20.3693 40.4161 20.6546 40.4579 20.9378 40.4321C21.2209 40.4064 21.494 40.3138 21.7344 40.162V40.1584Z",
    fill: "url(#paint18_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0791 61.325H32.6084C32.6084 61.325 33.157 64.578 32.6856 65.6624H28.292C28.292 65.6624 28.0509 64.7226 28.163 64.1672C28.163 64.1672 27.2419 64.4997 26.5028 64.1057C26.5028 64.1057 26.5402 65.4684 26.3822 65.6624H21.9972C21.9972 65.6624 21.4606 65.1142 22.0791 61.325Z",
    fill: "url(#paint19_linear)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M26.1879 65.5345C26.1879 65.5345 26.599 66.0068 26.5062 64.1465C26.3001 63.9889 26.1131 63.8078 25.9492 63.6068C25.932 63.5835 25.9167 63.5589 25.9033 63.5333C25.7659 63.2778 26.2096 64.3152 26.2096 64.3152L25.5706 63.7863L26.3193 64.6875L25.5706 64.5212L26.1879 65.02C26.1879 65.02 25.1389 65.3923 24.2383 65.02L24.6145 65.5345H26.1879Z",
    fill: "#077CA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M28.5573 65.541C28.5573 65.541 28.0751 66.0229 28.1631 64.1663C28.3711 63.9685 28.5648 63.7563 28.743 63.5313C28.7602 63.508 28.7755 63.4835 28.7888 63.4578C28.9263 63.2024 28.4826 64.2398 28.4826 64.2398L29.1216 63.712L28.3729 64.6121L29.1216 64.4458L28.5055 64.9446C28.5055 64.9446 29.5532 65.3169 30.4539 64.9446L30.0825 65.4591L28.5573 65.541Z",
    fill: "#077CA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M22.3338 62.0463L24.1423 64.1584L22.7823 63.4945L23.7818 64.5415L22.4954 64.1584C22.4954 64.1584 23.0982 65.0258 23.449 65.1764C23.7999 65.327 22.9005 65.4957 22.9005 65.4957L21.9359 65.4114C21.9359 65.4114 21.5525 64.4572 21.9636 62.233L22.2578 61.8921V62.0463",
    fill: "#077CA0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M32.3388 62.0455L30.5303 64.1575L31.8891 63.4937L30.8908 64.5407L32.1772 64.1575C32.1772 64.1575 31.5744 65.025 31.2235 65.1756C30.8727 65.3262 31.7721 65.4949 31.7721 65.4949L32.7367 65.4106C32.7367 65.4106 33.1201 64.4563 32.7089 62.2322L32.4148 61.8912V62.0455",
    fill: "#077CA0"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M23.1094 61.7059C23.1094 61.7059 25.4713 63.4673 28.7845 62.777C32.0978 62.0866 29.8914 61.5287 29.8914 61.5287L23.1094 61.7059Z",
    fill: "#077CA0"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9613 62.0684L22.0722 61.325H32.6015L32.7341 62.2744H21.9336L21.9613 62.0684Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M26.418 61.3677V62.234H28.2398V61.3677H26.418ZM28.1059 62.1087H26.5494V61.4918H28.1059V62.1087Z",
    fill: "url(#paint20_linear)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4169 61.5625C27.3692 61.5625 27.3226 61.5767 27.2829 61.6031C27.2433 61.6296 27.2124 61.6673 27.1941 61.7113C27.1759 61.7553 27.1711 61.8038 27.1804 61.8505C27.1897 61.8973 27.2127 61.9402 27.2464 61.9739C27.2801 62.0076 27.3231 62.0305 27.3699 62.0398C27.4167 62.0491 27.4651 62.0444 27.5092 62.0261C27.5533 62.0079 27.5909 61.977 27.6174 61.9374C27.6439 61.8978 27.6581 61.8512 27.6581 61.8035C27.6581 61.7396 27.6327 61.6783 27.5874 61.6331C27.5422 61.5879 27.4809 61.5625 27.4169 61.5625ZM27.4169 61.9505C27.3881 61.9505 27.3599 61.9419 27.3359 61.9259C27.3119 61.9099 27.2932 61.8871 27.2821 61.8605C27.2711 61.8339 27.2682 61.8045 27.2738 61.7763C27.2795 61.748 27.2934 61.722 27.3138 61.7016C27.3342 61.6812 27.3602 61.6673 27.3885 61.6617C27.4168 61.6561 27.4461 61.659 27.4727 61.67C27.4994 61.6811 27.5222 61.6997 27.5382 61.7237C27.5543 61.7477 27.5628 61.7759 27.5628 61.8047C27.5628 61.8434 27.5474 61.8805 27.5201 61.9078C27.4927 61.9351 27.4556 61.9505 27.4169 61.9505Z",
    fill: "url(#paint21_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4758 61.7161H26.5498V61.892H27.4758V61.7161Z",
    fill: "url(#paint22_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9963 65.6631H26.3838C26.4513 65.6631 26.4694 65.327 26.4694 65.327L21.8564 65.2764C21.8564 65.2764 21.9336 65.6402 21.9963 65.6631Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6958 65.6638H28.3083C28.2407 65.6638 28.2227 65.3276 28.2227 65.3276H32.779C32.779 65.3276 32.7585 65.6409 32.6958 65.6638Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2876 53.6498C21.5413 55.4149 22.2515 58.7041 22.2515 58.7041H22.4275C22.4275 58.7041 22.1984 59.9186 22.0091 61.3547C21.7837 63.0487 32.8603 63.1897 32.6529 61.6041C32.4576 60.068 32.202 58.7125 32.202 58.7125C32.202 58.7125 32.8941 55.7908 32.3913 53.9775C30.853 54.8956 29.0835 55.3536 27.2926 55.297C25.5018 55.2404 23.7648 54.6716 22.2876 53.6582V53.6498Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.2876 53.6498C21.5413 55.4149 22.2515 58.7041 22.2515 58.7041H22.4275C22.4275 58.7041 22.1984 59.9186 22.0091 61.3547C21.7837 63.0487 32.8603 63.1897 32.6529 61.6041C32.4576 60.068 32.202 58.7125 32.202 58.7125C32.202 58.7125 32.8941 55.7908 32.3913 53.9775C30.853 54.8956 29.0835 55.3536 27.2926 55.297C25.5018 55.2404 23.7648 54.6716 22.2876 53.6582V53.6498Z",
    fill: "#6D6D6D"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M32.621 61.3798C32.621 61.3798 32.6282 61.4304 32.6511 61.6027C32.8525 63.1883 21.7818 63.0485 22.0073 61.3533L22.0314 61.1714C26.6166 62.6834 28.2865 62.4931 32.621 61.3798Z",
    fill: "#FFCA07"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.621 61.3798C32.621 61.3798 32.6282 61.4304 32.6511 61.6027C32.8525 63.1883 21.7818 63.0485 22.0073 61.3533L22.0314 61.1714C26.6166 62.6834 28.2865 62.4931 32.621 61.3798Z",
    fill: "#B47C2B"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0344 57.0874C19.0066 57.1946 22.2487 58.7055 22.2487 58.7055H22.4235C22.4235 58.7055 23.8704 56.8922 24.859 54.8898C23.6193 54.5123 22.4717 53.8812 21.4891 53.0367C19.8832 54.1235 19.1971 56.4476 19.0344 57.0874Z",
    fill: "#FFCA07"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.0344 57.0874C19.0066 57.1946 22.2487 58.7055 22.2487 58.7055H22.4235C22.4235 58.7055 23.8704 56.8922 24.859 54.8898C23.6193 54.5123 22.4717 53.8812 21.4891 53.0367C19.8832 54.1235 19.1971 56.4476 19.0344 57.0874Z",
    fill: "#B47C2B"
  }))), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4198 53.2544C32.3999 54.0699 31.2203 54.6625 29.957 54.9942C30.6322 56.3062 31.2978 57.628 32.2105 58.7725C32.2105 58.7725 35.6153 57.2123 35.5948 57.1304C35.4586 56.5846 34.8557 54.4339 33.4198 53.2544Z",
    fill: "#FFCA07"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.4198 53.2544C32.3999 54.0699 31.2203 54.6625 29.957 54.9942C30.6322 56.3062 31.2978 57.628 32.2105 58.7725C32.2105 58.7725 35.6153 57.2123 35.5948 57.1304C35.4586 56.5846 34.8557 54.4339 33.4198 53.2544Z",
    fill: "#B47C2B"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M33.4227 53.2544C33.1416 53.4776 32.8481 53.6847 32.5437 53.8749C32.7327 53.8647 32.9208 53.8417 33.1068 53.8062C33.1538 53.7977 33.3322 53.5941 33.3901 53.6508C33.5107 53.564 33.5505 53.6447 33.7301 53.6508C33.6517 53.7134 33.5697 53.8411 33.4094 53.8676C33.3171 53.9073 33.2197 53.9341 33.12 53.9471C33.12 53.9471 33.2816 54.1243 33.6602 54.0026C33.6769 53.9888 33.6961 53.9786 33.7168 53.9724C33.7375 53.9662 33.7592 53.9641 33.7807 53.9664L33.6602 54.0026C33.4974 54.117 34.2124 55.0327 34.3137 54.9086C34.3498 55.0544 34.2606 55.2351 34.2353 55.3905C34.2217 55.5522 34.1996 55.7131 34.169 55.8725C34.1075 56.0821 33.9568 56.2339 33.8278 56.4183C33.6988 56.6026 33.5396 56.7942 33.2961 56.846C33.8579 56.8785 34.2389 56.4098 34.6597 56.1134C34.6705 56.3038 34.6597 56.4966 34.6597 56.6881C34.781 56.6979 34.903 56.6885 35.0214 56.6604C35.1793 56.9942 34.9213 57.1086 34.6862 57.2629C34.3735 57.4705 34.0486 57.6591 33.7132 57.8279C33.1854 58.0995 32.6827 58.4172 32.2109 58.7773C32.2109 58.7773 35.6158 57.2171 35.5953 57.1351C35.4615 56.5845 34.8586 54.4339 33.4227 53.2544Z",
    fill: "#B5933C"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M21.2217 53.2544C21.5026 53.4779 21.7961 53.685 22.1007 53.8749C21.9113 53.8647 21.7227 53.8418 21.5364 53.8062C21.4906 53.7978 21.3122 53.5942 21.2543 53.6508C21.1337 53.564 21.0927 53.6448 20.9143 53.6508C20.9927 53.7134 21.0746 53.8411 21.2338 53.8677C21.3261 53.9073 21.4235 53.9341 21.5232 53.9472C21.5232 53.9472 21.3628 54.1243 20.9842 54.0026C20.9675 53.9889 20.9482 53.9787 20.9275 53.9725C20.9068 53.9663 20.8851 53.9642 20.8636 53.9665L20.9842 54.0026C21.147 54.1171 20.4308 55.0327 20.3295 54.9086C20.2934 55.0544 20.3826 55.2351 20.4091 55.3906C20.4221 55.5523 20.4442 55.7132 20.4754 55.8725C20.5369 56.0821 20.6876 56.234 20.8154 56.4183C20.9432 56.6026 21.1048 56.7942 21.3483 56.846C20.7865 56.8785 20.4043 56.4099 19.9847 56.1135C19.9738 56.3038 19.9847 56.4966 19.9787 56.6882C19.8574 56.6979 19.7353 56.6886 19.617 56.6605C19.459 56.9942 19.717 57.1087 19.9521 57.2629C20.2647 57.4707 20.5897 57.6594 20.9251 57.828C21.453 58.0995 21.9557 58.4172 22.4274 58.7774C22.4274 58.7774 19.0226 57.2171 19.0431 57.1352C19.1829 56.5846 19.7858 54.4339 21.2217 53.2544Z",
    fill: "#B5933C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3449 61.7231C25.111 61.6641 24.742 61.5629 24.5009 61.5051C24.238 61.4412 23.5833 60.987 23.675 60.7195C23.9554 60.6739 24.2328 60.6116 24.5057 60.5328C24.6709 60.4785 25.1893 60.3448 25.2641 60.2207C24.8518 60.2098 24.4408 60.1695 24.0343 60.1002C23.5713 60.0038 23.4917 59.5183 23.136 59.2894C23.5484 59.2653 23.98 59.3062 24.3887 59.2677C24.648 59.2436 24.8807 59.1665 25.1375 59.1472C24.8578 59.1472 24.695 59.0556 24.4322 58.9629C23.3832 58.5954 23.3651 57.905 23.5231 57.8604C23.8245 57.7773 24.1368 58.0809 24.6371 58.2351C24.9048 58.3171 25.9103 58.5472 26.4746 58.2568C26.9713 58.0002 28.2566 57.5086 28.0974 56.9315C26.19 58.3171 25.299 57.5484 24.197 56.3893C23.5098 57.1821 22.913 58.3171 22.6875 58.7641C22.4621 59.211 22.2631 60.0195 22.151 60.8665C22.0666 61.5039 25.3822 62.0918 27.2715 61.9605C27.0208 61.8882 26.1515 61.9256 25.3449 61.7231Z",
    fill: "#B6B6B7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.33
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2749 61.7987C30.4401 61.7577 30.7005 61.6867 30.8669 61.6457C31.0514 61.6011 31.512 61.2842 31.4481 61.0927C31.2506 61.0611 31.0553 61.0173 30.8633 60.9614C30.7427 60.9228 30.381 60.8288 30.3292 60.7409C30.6194 60.7348 30.9087 60.7075 31.1949 60.6589C31.5204 60.5903 31.5771 60.2493 31.8278 60.0878C31.5373 60.071 31.2359 60.0999 30.9453 60.0722C30.7632 60.0553 30.5993 60.0011 30.4184 59.9878C30.5907 59.9761 30.7592 59.9319 30.9151 59.8577C31.653 59.5975 31.6663 59.1119 31.5542 59.0818C31.3432 59.0228 31.1225 59.236 30.7705 59.3445C30.5812 59.4023 29.8734 59.5649 29.4768 59.3601C29.1271 59.1794 28.2216 58.8336 28.3338 58.43C29.6769 59.4047 30.6077 58.671 31.3842 57.8601C31.8664 58.4179 31.9231 58.7035 32.2113 59.3481C32.3535 59.6686 32.4415 60.6035 32.5211 61.2011C32.5802 61.6493 30.246 62.0626 28.9149 61.971C29.0958 61.9144 29.707 61.9421 30.2749 61.7987Z",
    fill: "#B6B6B7"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9287 39.1519L25.3164 37.2145L20.9856 22.9661L18.9287 39.1519Z",
    fill: "#065FE5"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9844 22.9661L25.3152 37.2145L31.7017 35.2759L20.9844 22.9661Z",
    fill: "#1C57B1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M22.042 22.6436C22.1058 22.8527 22.1062 23.076 22.043 23.2852C21.9797 23.4945 21.8558 23.6804 21.6869 23.8192C21.5179 23.9581 21.3115 24.0438 21.0939 24.0654C20.8762 24.087 20.657 24.0436 20.464 23.9407C20.271 23.8378 20.1129 23.6799 20.0097 23.4872C19.9065 23.2944 19.8628 23.0754 19.8842 22.8579C19.9056 22.6403 19.9911 22.434 20.1299 22.265C20.2687 22.096 20.4546 21.972 20.6639 21.9086C20.8027 21.8664 20.9484 21.852 21.0928 21.8661C21.2372 21.8802 21.3773 21.9226 21.5053 21.9908C21.6333 22.0591 21.7465 22.1518 21.8386 22.2638C21.9307 22.3758 21.9998 22.5049 22.042 22.6436Z",
    fill: "#FD8114"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6643 21.9088C20.4836 21.9818 20.3281 22.1056 20.2166 22.2654C20.1052 22.4251 20.0426 22.6137 20.0366 22.8083C20.0306 23.003 20.0813 23.1951 20.1827 23.3614C20.284 23.5277 20.4316 23.661 20.6074 23.7449C20.7832 23.8289 20.9796 23.8599 21.1728 23.8343C21.3659 23.8086 21.5474 23.7274 21.6952 23.6004C21.843 23.4735 21.9506 23.3064 22.0049 23.1194C22.0593 22.9324 22.058 22.7337 22.0014 22.5474C21.8978 22.2939 21.7035 22.088 21.4563 21.97C21.209 21.8519 20.9267 21.8301 20.6643 21.9088Z",
    fill: "#FDA014"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6057 34.9266C27.74 34.886 27.8591 34.8066 27.9481 34.6983C28.0372 34.59 28.0921 34.4578 28.1059 34.3183C28.1197 34.1788 28.0918 34.0384 28.0257 33.9148C27.9596 33.7912 27.8583 33.6899 27.7347 33.6239C27.611 33.5578 27.4705 33.5298 27.3309 33.5435C27.1914 33.5573 27.059 33.612 26.9506 33.7009C26.8422 33.7898 26.7626 33.9089 26.7219 34.043C26.6812 34.1771 26.6812 34.3202 26.722 34.4543C26.7766 34.634 26.9003 34.7847 27.066 34.8733C27.2317 34.9619 27.4259 34.981 27.6057 34.9266Z",
    fill: "#FDC63A"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3871 30.3999C26.3259 30.194 26.2048 30.0109 26.0393 29.8738C25.8738 29.7367 25.6713 29.6518 25.4575 29.6299C25.2436 29.608 25.0281 29.6501 24.8382 29.7508C24.6483 29.8515 24.4926 30.0063 24.3909 30.1955C24.2892 30.3847 24.246 30.5999 24.2668 30.8137C24.2877 31.0275 24.3716 31.2303 24.5079 31.3964C24.6443 31.5625 24.8269 31.6843 25.0327 31.7465C25.2384 31.8087 25.458 31.8084 25.6636 31.7457C25.9375 31.6622 26.1673 31.4738 26.3028 31.2217C26.4383 30.9697 26.4686 30.6742 26.3871 30.3999Z",
    fill: "#FDC63A"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5504 26.0533C23.4328 26.0888 23.3265 26.1543 23.2419 26.2433C23.1573 26.3323 23.0972 26.4417 23.0677 26.5609C23.0381 26.68 23.0401 26.8048 23.0733 26.923C23.1065 27.0411 23.1699 27.1487 23.2573 27.235C23.3446 27.3213 23.4529 27.3835 23.5715 27.4154C23.6901 27.4473 23.815 27.4479 23.9339 27.417C24.0528 27.3862 24.1616 27.325 24.2498 27.2395C24.3379 27.154 24.4022 27.047 24.4365 26.9292L23.6553 26.0328C23.6198 26.0368 23.5847 26.0437 23.5504 26.0533Z",
    fill: "#FDC63A"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0686 31.5876L27.3838 31.9093L28.0554 32.2575L28.1506 33.0081L28.6895 32.4768L29.3792 32.6081L28.1361 31.1804L28.0686 31.5876Z",
    fill: "#FDC63A"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9429 34.692C31.0054 34.6738 31.0633 34.6426 31.1129 34.6005L30.4788 33.8716C30.3962 33.9447 30.3412 34.044 30.323 34.1528C30.3048 34.2616 30.3245 34.3733 30.3789 34.4694C30.4332 34.5654 30.5188 34.6399 30.6215 34.6804C30.7241 34.7209 30.8376 34.725 30.9429 34.692Z",
    fill: "#FDC63A"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M25.838 36.4444L25.3207 35.8914L25.1978 36.6384L24.5117 36.96L25.117 37.2733L25.3183 37.2131L26.2575 36.9275L26.5867 36.3299L25.838 36.4444Z",
    fill: "#FDC63A"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4368 32.2798L22.9184 31.728L22.7954 32.475L22.1094 32.7955L22.7821 33.1437L22.8762 33.8943L23.4151 33.363L24.159 33.5052L23.819 32.8293L24.1856 32.1666L23.4368 32.2798Z",
    fill: "#FDC63A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7212 29.8066L20.3812 29.1307L20.7465 28.468L20.2799 28.5391L20.1328 29.6945L20.7212 29.8066Z",
    fill: "#FDC63A"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5541 32.9109C20.648 32.8886 20.7363 32.8474 20.8137 32.7898C20.8911 32.7321 20.9559 32.6594 21.0041 32.5759C21.0524 32.4923 21.083 32.3999 21.0943 32.3041C21.1055 32.2084 21.0971 32.1113 21.0694 32.0189C21.0418 31.9265 20.9956 31.8407 20.9337 31.7668C20.8717 31.6929 20.7953 31.6324 20.7092 31.589C20.623 31.5456 20.5289 31.5203 20.4326 31.5145C20.3363 31.5087 20.2398 31.5227 20.149 31.5554C20.0489 31.5859 19.957 31.6386 19.8802 31.7097L19.7656 32.6205C19.8486 32.7469 19.97 32.8433 20.112 32.8956C20.2539 32.9479 20.4089 32.9532 20.5541 32.9109Z",
    fill: "#FDC63A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9348 38.1479C20.1825 38.0452 20.3834 37.8544 20.4986 37.6124C20.6139 37.3704 20.6354 37.0944 20.559 36.8375C20.4826 36.5806 20.3137 36.361 20.0849 36.2212C19.8561 36.0814 19.5835 36.0313 19.3199 36.0804L19.0703 38.0395C19.1987 38.1173 19.342 38.1672 19.491 38.1859C19.6399 38.2046 19.7912 38.1916 19.9348 38.1479Z",
    fill: "#FDC63A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9312 35.605C22.959 35.6961 23.0131 35.7769 23.0868 35.8372C23.1605 35.8975 23.2505 35.9347 23.3453 35.944C23.4401 35.9533 23.5355 35.9343 23.6196 35.8895C23.7036 35.8447 23.7725 35.7759 23.8175 35.692C23.8625 35.6081 23.8816 35.5128 23.8725 35.418C23.8633 35.3233 23.8263 35.2333 23.766 35.1596C23.7058 35.0858 23.625 35.0316 23.5339 35.0036C23.4429 34.9757 23.3456 34.9753 23.2543 35.0026C23.1934 35.0208 23.1367 35.0509 23.0874 35.091C23.0382 35.1312 22.9974 35.1807 22.9674 35.2367C22.9373 35.2927 22.9187 35.354 22.9125 35.4173C22.9063 35.4805 22.9126 35.5443 22.9312 35.605Z",
    fill: "#FDC63A"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9069 26.7767C21.0298 26.7394 21.133 26.6549 21.1936 26.5417C21.2542 26.4285 21.2673 26.2959 21.23 26.173C21.1928 26.0502 21.1082 25.9471 20.9949 25.8866C20.8816 25.826 20.7489 25.8129 20.626 25.8501H20.6175L20.5078 26.7164C20.566 26.7547 20.6319 26.7799 20.7007 26.7903C20.7696 26.8007 20.84 26.796 20.9069 26.7767Z",
    fill: "#FDC63A"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9987 28.7037C21.9076 28.7315 21.8268 28.7856 21.7664 28.8592C21.706 28.9329 21.6688 29.0228 21.6595 29.1175C21.6502 29.2122 21.6692 29.3076 21.7141 29.3916C21.7589 29.4756 21.8277 29.5444 21.9117 29.5894C21.9956 29.6344 22.0911 29.6535 22.1859 29.6443C22.2807 29.6352 22.3707 29.5981 22.4445 29.5379C22.5183 29.4777 22.5726 29.397 22.6006 29.306C22.6285 29.215 22.6289 29.1178 22.6016 29.0266C22.5834 28.9657 22.5533 28.909 22.5131 28.8598C22.4729 28.8106 22.4234 28.7699 22.3673 28.7398C22.3113 28.7098 22.2499 28.6912 22.1866 28.685C22.1234 28.6788 22.0595 28.6851 21.9987 28.7037Z",
    fill: "#FDC63A"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6047 35.883C32.4696 35.4372 32.0344 35.1746 31.2784 35.4011L19.3554 39.0156C18.5958 39.2457 18.3824 39.706 18.5174 40.1517C18.5174 40.165 18.5283 40.177 18.5331 40.1903L32.6143 35.9179C32.6119 35.9061 32.6087 35.8944 32.6047 35.883Z",
    fill: "#FDC63A"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5322 40.1956C18.6817 40.6161 19.1098 40.8583 19.8452 40.6354L31.7683 37.0209C32.5037 36.7968 32.7244 36.3582 32.6122 35.9269L18.5322 40.1956Z",
    fill: "#F26283"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 38.5855L18.9287 39.1518L25.3164 37.2144L31.703 35.2758L31.328 34.8445L18.9998 38.5855Z",
    fill: "#D1D1D1"
  })))), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6404 54.4684C53.855 54.719 57.4443 58.8396 58.2762 54.4793C58.2762 54.4793 54.6953 48.2731 48.5463 47.9731L47.7578 49.7684C47.7578 49.7684 53.8224 54.7046 53.6404 54.4684Z",
    fill: "#F7BED7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M53.6404 54.4684C53.855 54.719 57.4443 58.8396 58.2762 54.4793C58.2762 54.4793 54.6953 48.2731 48.5463 47.9731L47.7578 49.7684C47.7578 49.7684 53.8224 54.7046 53.6404 54.4684Z",
    fill: "#9C1B43"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M55.138 61.8612L53.0486 62.448C53.0486 62.448 53.1125 62.7877 53.1064 62.801C53.1004 62.8142 53.3283 66.0468 51.943 66.0613C51.6464 66.0613 51.2847 66.0878 50.8916 66.1083C52.3577 66.0516 54.2229 66.2022 54.8704 64.9372C55.0789 64.5203 55.1513 63.0046 55.138 61.8612Z",
    fill: "#F7BED7"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M55.138 61.8612L53.0486 62.448C53.0486 62.448 53.1125 62.7877 53.1064 62.801C53.1004 62.8142 53.3283 66.0468 51.943 66.0613C51.6464 66.0613 51.2847 66.0878 50.8916 66.1083C52.3577 66.0516 54.2229 66.2022 54.8704 64.9372C55.0789 64.5203 55.1513 63.0046 55.138 61.8612Z",
    fill: "#9C1B43"
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7383 53.3181C42.7383 53.3181 47.4188 47.1373 53.5159 48.1096V50.8808L53.956 50.2952C53.956 50.2952 54.6167 54.7941 54.7505 55.9242C54.8844 57.0543 56.4723 58.1279 55.9213 60.6339C55.5354 62.3845 53.1482 62.8918 53.0276 62.8099C53.0276 62.8099 53.2495 66.0557 51.8629 66.0701C50.4764 66.0846 47.6551 66.5521 46.84 64.946C46.6218 64.5183 46.5543 63.2388 46.57 62.0665C43.7583 57.6724 47.0739 54.523 47.2934 54.2989C47.0366 54.5326 42.7383 58.3785 42.7383 53.323",
    fill: "#F7BED7"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.63
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M42.7383 53.3181C42.7383 53.3181 47.4188 47.1373 53.5159 48.1096V50.8808L53.956 50.2952C53.956 50.2952 54.6167 54.7941 54.7505 55.9242C54.8844 57.0543 56.4723 58.1279 55.9213 60.6339C55.5354 62.3845 53.1482 62.8918 53.0276 62.8099C53.0276 62.8099 53.2495 66.0557 51.8629 66.0701C50.4764 66.0846 47.6551 66.5521 46.84 64.946C46.6218 64.5183 46.5543 63.2388 46.57 62.0665C43.7583 57.6724 47.0739 54.523 47.2934 54.2989C47.0366 54.5326 42.7383 58.3785 42.7383 53.323",
    fill: "#9C1B43"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6973 52.5532C43.6973 52.5532 42.6629 54.7545 44.8536 55.7099C44.8536 55.7099 41.7297 55.4918 43.6973 52.5532Z",
    fill: "url(#paint23_linear)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7312 53.7808C57.7312 53.7808 57.9591 55.9242 55.5742 56.07C55.5742 56.0663 58.5824 56.8157 57.7312 53.7808Z",
    fill: "url(#paint24_linear)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2821 62.3818C47.2821 62.3818 46.6383 64.8553 50.0552 65.6469C50.0492 65.6469 46.144 66.0927 47.2821 62.3818Z",
    fill: "url(#paint25_linear)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7952 62.4146C54.7952 62.4146 55.2992 64.8881 52.625 65.6797C52.6238 65.6797 55.6874 66.1242 54.7952 62.4146Z",
    fill: "url(#paint26_linear)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4412 58.621L55.8993 58.6451C55.8993 58.6451 56.4696 60.8391 55.1386 61.9596C55.1386 61.9596 55.065 64.1283 55.018 64.4199L53.019 64.597C53.019 64.597 53.1793 63.238 53.0443 62.8681H53.0286C53.0286 62.8681 53.0672 64.3283 52.9442 64.6344C52.9442 64.6344 46.7434 64.8247 46.6951 64.4898C46.6469 64.1548 46.4637 62.144 46.4637 62.144C46.4637 62.144 45.3303 60.3126 45.4412 58.621Z",
    fill: "#7D1416"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M45.4412 58.621L55.8993 58.6451C55.8993 58.6451 56.4696 60.8391 55.1386 61.9596C55.1386 61.9596 55.065 64.1283 55.018 64.4199L53.019 64.597C53.019 64.597 53.1793 63.238 53.0443 62.8681H53.0286C53.0286 62.8681 53.0672 64.3283 52.9442 64.6344C52.9442 64.6344 46.7434 64.8247 46.6951 64.4898C46.6469 64.1548 46.4637 62.144 46.4637 62.144C46.4637 62.144 45.3303 60.3126 45.4412 58.621Z",
    fill: "#550F0E"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M55.0375 61.7958L53.7872 62.9464L54.5672 62.7488C54.5672 62.7488 53.8631 63.4717 53.4592 63.403C53.0553 63.3343 53.3929 63.403 53.3929 63.403C53.3929 63.403 54.1983 63.5235 54.3997 63.403L53.9174 63.8344L54.7409 63.7139L53.8897 64.5091L55.0182 64.4091C55.0182 64.4091 55.2894 62.2994 55.0375 61.7958Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5738 58.6451C45.5288 58.6457 45.4842 58.6376 45.4424 58.621C45.4424 59.6548 45.7414 60.8367 46.5673 62.1283C46.5516 63.3006 53.0249 62.8717 53.0249 62.8717C53.1455 62.9536 55.5352 62.4464 55.9186 60.6958C56.0793 60.0216 56.0722 59.3184 55.8981 58.6475L45.5738 58.6451Z",
    fill: "url(#paint27_linear)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8522 59.1949C47.8522 59.1949 47.2168 61.3805 46.1317 61.3479L45.9219 60.9106C45.9219 60.9106 47.2783 60.3853 47.4784 59.1949L47.8522 58.9937V59.1949Z",
    fill: "#9E3535"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2253 60.6111L47.1288 60.5569C47.0951 60.6147 47.0625 60.6774 47.0264 60.728L47.1192 60.7882C47.1566 60.7304 47.1903 60.6701 47.2253 60.6111Z",
    fill: "#202020"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3963 60.285L47.2963 60.2368C47.2661 60.2971 47.2384 60.3573 47.207 60.4176L47.3047 60.4682C47.3336 60.4079 47.3626 60.3465 47.3963 60.285Z",
    fill: "#202020"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5451 59.9528L47.4438 59.9082L47.3594 60.0925L47.4607 60.1383L47.5451 59.9528Z",
    fill: "#202020"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4234 61.3582L46.398 61.251C46.3675 61.2582 46.3365 61.2634 46.3052 61.2667C46.2738 61.2721 46.2419 61.2745 46.21 61.2739V61.3847C46.2805 61.3823 46.3508 61.3734 46.4197 61.3582H46.4234Z",
    fill: "#202020"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7657 61.1942L46.6982 61.1074C46.6742 61.1271 46.6484 61.1445 46.621 61.1592C46.5957 61.1771 46.5681 61.1917 46.5391 61.2026L46.5837 61.3038C46.6152 61.2921 46.6455 61.2771 46.6741 61.2592C46.7067 61.2406 46.7374 61.2188 46.7657 61.1942Z",
    fill: "#202020"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0262 60.9247L46.937 60.8584C46.9 60.9099 46.8597 60.959 46.8164 61.0054L46.8948 61.0825C46.942 61.0329 46.9859 60.9801 47.0262 60.9247Z",
    fill: "#202020"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3745 59.1877L47.1025 59.3336L47.155 59.4313L47.4269 59.2854L47.3745 59.1877Z",
    fill: "#202020"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8623 58.9223L47.5898 59.0681L47.6429 59.1656L47.7514 59.1078V59.1741V59.1861L47.8599 59.2138L47.8671 59.1946V59.1849V58.9126L47.8623 58.9223Z",
    fill: "#202020"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.756 59.4626L47.6548 59.4204L47.5342 59.7036L47.6355 59.7469L47.756 59.4626Z",
    fill: "#202020"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9016 58.7133L56.0222 59.4073C56.0222 59.4073 46.8059 59.976 45.5833 59.9965C45.5833 59.9965 45.3313 58.988 45.4423 58.6892L55.9016 58.7133Z",
    fill: "#0F0708"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8983 58.6457L56.0188 59.3397C56.0188 59.3397 46.8038 59.9096 45.5872 59.9337C45.5872 59.9337 45.3353 58.924 45.4462 58.6252L55.8983 58.6457Z",
    fill: "#832C2C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M46.6016 64.1598V62.2477C46.6016 62.2477 47.3672 61.1344 48.4993 60.8115C48.4993 60.8115 47.7675 61.4718 47.5866 61.8164C47.5715 61.8439 47.5594 61.873 47.5504 61.9031C47.4781 62.2055 49.3481 61.2091 50.1957 61.1802L48.2003 62.414L50.7238 62.7356L50.8359 62.7489C50.8359 62.7489 48.5246 63.0983 48.1762 63.4718C48.1762 63.4718 51.6027 63.42 51.7932 63.4224C51.7932 63.4224 48.0785 64.1296 47.8543 64.1236C47.63 64.1176 46.6016 64.1598 46.6016 64.1598Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M45.4453 58.8586L45.5731 59.6888C47.0256 59.7084 48.4758 59.569 49.8979 59.2731C49.8979 59.2731 45.7564 59.2972 45.4453 58.8586Z",
    fill: "#E0C198"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M55.8991 58.6466L56.0197 59.3406C56.0197 59.3406 51.9469 59.3478 49.8984 59.0274C49.8996 59.0274 55.1805 59.025 55.8991 58.6466Z",
    fill: "#503614"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9319 64.6937L53.0392 64.2346L46.6057 64.1599C46.6057 64.1599 46.5442 64.4828 46.7612 64.5539C47.0739 64.6393 47.3934 64.6974 47.7161 64.7274C49.4542 64.8044 51.195 64.7932 52.9319 64.6937Z",
    fill: "#7D1416"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M52.9319 64.6937L53.0392 64.2346L46.6057 64.1599C46.6057 64.1599 46.5442 64.4828 46.7612 64.5539C47.0739 64.6393 47.3934 64.6974 47.7161 64.7274C49.4542 64.8044 51.195 64.7932 52.9319 64.6937Z",
    fill: "#95783C"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3946 64.1428L47.3936 64.2537L47.5925 64.2555L47.5935 64.1447L47.3946 64.1428Z",
    fill: "#202020"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0362 64.1414L47.0352 64.2522L47.2341 64.254L47.2351 64.1432L47.0362 64.1414Z",
    fill: "#202020"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6807 64.1372L46.6797 64.248L46.8786 64.2499L46.8796 64.139L46.6807 64.1372Z",
    fill: "#202020"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4698 64.1528L48.4688 64.2637L48.6677 64.2655L48.6687 64.1547L48.4698 64.1528Z",
    fill: "#202020"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1104 64.15L48.1094 64.2608L48.3083 64.2626L48.3093 64.1518L48.1104 64.15Z",
    fill: "#202020"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7549 64.1471L47.7539 64.2579L47.9528 64.2598L47.9539 64.1489L47.7549 64.1471Z",
    fill: "#202020"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5401 64.1628L49.5391 64.2737L49.738 64.2755L49.739 64.1647L49.5401 64.1628Z",
    fill: "#202020"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1846 64.1599L49.1836 64.2708L49.3825 64.2726L49.3835 64.1618L49.1846 64.1599Z",
    fill: "#202020"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8252 64.157L48.8242 64.2678L49.0232 64.2697L49.0242 64.1588L48.8252 64.157Z",
    fill: "#202020"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6133 64.1727L50.6123 64.2835L50.8112 64.2854L50.8123 64.1746L50.6133 64.1727Z",
    fill: "#202020"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2549 64.1699L50.2539 64.2808L50.4528 64.2826L50.4539 64.1718L50.2549 64.1699Z",
    fill: "#202020"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8995 64.167L49.8984 64.2778L50.0974 64.2797L50.0984 64.1688L49.8995 64.167Z",
    fill: "#202020"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6846 64.1812L51.6836 64.292L51.8825 64.2938L51.8835 64.183L51.6846 64.1812Z",
    fill: "#202020"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3292 64.1812L51.3281 64.2921L51.5271 64.2939L51.5281 64.1831L51.3292 64.1812Z",
    fill: "#202020"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9737 64.1755L50.9727 64.2864L51.1716 64.2882L51.1726 64.1774L50.9737 64.1755Z",
    fill: "#202020"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7588 64.1926L52.7578 64.3035L52.9567 64.3053L52.9578 64.1945L52.7588 64.1926Z",
    fill: "#202020"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4034 64.1898L52.4023 64.3006L52.6013 64.3024L52.6023 64.1916L52.4034 64.1898Z",
    fill: "#202020"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0479 64.1855L52.0469 64.2963L52.2458 64.2982L52.2468 64.1873L52.0479 64.1855Z",
    fill: "#202020"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0146 64.6182L53.0267 64.4278L55.0173 64.3917C55.0265 64.445 55.0236 64.4998 55.0088 64.5519C54.9703 64.617 54.8135 64.6254 54.7364 64.6338C54.1627 64.664 53.5877 64.6587 53.0146 64.6182Z",
    fill: "#7D1416"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M53.0146 64.6182L53.0267 64.4278L55.0173 64.3917C55.0265 64.445 55.0236 64.4998 55.0088 64.5519C54.9703 64.617 54.8135 64.6254 54.7364 64.6338C54.1627 64.664 53.5877 64.6587 53.0146 64.6182Z",
    fill: "#95783C"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2821 64.3346L54.0977 64.3376L54.0994 64.4484L54.2839 64.4454L54.2821 64.3346Z",
    fill: "#202020"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6132 64.3289L54.4287 64.3319L54.4305 64.4427L54.6149 64.4398L54.6132 64.3289Z",
    fill: "#202020"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9423 64.3232L54.7578 64.3262L54.7596 64.437L54.9441 64.434L54.9423 64.3232Z",
    fill: "#202020"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M53.286 64.3503L53.1016 64.3533L53.1033 64.4641L53.2878 64.4612L53.286 64.3503Z",
    fill: "#202020"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M53.618 64.346L53.4336 64.349L53.4354 64.4598L53.6198 64.4568L53.618 64.346Z",
    fill: "#202020"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9491 64.3403L53.7646 64.3433L53.7664 64.4541L53.9509 64.4512L53.9491 64.3403Z",
    fill: "#202020"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M44.457 51.5006L46.8455 54.6332C46.8455 54.6332 45.3348 56.3851 45.4698 57.9875L55.606 57.7863C55.606 57.7863 54.3835 55.032 54.3919 53.7898L53.9241 50.5452L45.7109 50.2958",
    fill: "#121212"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M44.457 51.5006L46.8455 54.6332C46.8455 54.6332 45.3348 56.3851 45.4698 57.9875L55.606 57.7863C55.606 57.7863 54.3835 55.032 54.3919 53.7898L53.9241 50.5452L45.7109 50.2958",
    fill: "#8D8D8D"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5234 51.4289L46.889 54.6314C46.889 54.6314 45.4156 56.3061 45.4808 57.9146L55.5772 57.7109C55.5772 57.7109 54.4511 54.9591 54.4559 53.7205L53.9881 50.4759L45.7725 50.2205",
    fill: "white"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M44.5234 51.4289L46.889 54.6314C46.889 54.6314 45.4156 56.3061 45.4808 57.9146L55.5772 57.7109C55.5772 57.7109 54.4511 54.9591 54.4559 53.7205L53.9881 50.4759L45.7725 50.2205",
    fill: "#8D8D8D"
  }))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M50.616 31.755C48.5774 31.755 46.5846 32.3591 44.8895 33.4909C43.1945 34.6227 41.8733 36.2314 41.0932 38.1135C40.3131 39.9956 40.1089 42.0666 40.5067 44.0647C40.9044 46.0627 41.8861 47.898 43.3276 49.3385C44.7691 50.779 46.6057 51.76 48.6051 52.1574C50.6046 52.5549 52.6771 52.3509 54.5605 51.5713C56.4439 50.7917 58.0537 49.4715 59.1863 47.7777C60.3189 46.0838 60.9234 44.0924 60.9234 42.0552C60.9231 39.3235 59.8371 36.7038 57.9041 34.7722C55.9712 32.8407 53.3496 31.7554 50.616 31.755Z",
    fill: "#F7BED7"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.616 31.755C48.5774 31.755 46.5846 32.3591 44.8895 33.4909C43.1945 34.6227 41.8733 36.2314 41.0932 38.1135C40.3131 39.9956 40.1089 42.0666 40.5067 44.0647C40.9044 46.0627 41.8861 47.898 43.3276 49.3385C44.7691 50.779 46.6057 51.76 48.6051 52.1574C50.6046 52.5549 52.6771 52.3509 54.5605 51.5713C56.4439 50.7917 58.0537 49.4715 59.1863 47.7777C60.3189 46.0838 60.9234 44.0924 60.9234 42.0552C60.9231 39.3235 59.8371 36.7038 57.9041 34.7722C55.9712 32.8407 53.3496 31.7554 50.616 31.755Z",
    fill: "#9C1B43"
  }))), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2705 33.5885C53.1952 35.3271 51.6676 37.9488 48.8511 39.4428C46.0347 40.9368 43.0072 40.7392 42.0824 39.0006C41.1577 37.262 42.6853 34.6403 45.5017 33.1463C48.3182 31.6523 51.3457 31.8499 52.2705 33.5885Z",
    fill: "url(#paint28_linear)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0752 34.4675C54.0752 34.4675 57.9334 35.294 58.8979 41.4556C58.8979 41.4556 57.4174 35.7422 54.0752 34.4675Z",
    fill: "url(#paint29_linear)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1133 50.2283C52.1133 50.2283 56.4019 49.9789 57.7342 44.4812C57.7342 44.4812 57.9343 49.6777 52.1133 50.2283Z",
    fill: "url(#paint30_linear)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6066 30.9565C52.6066 30.9565 44.5912 28.8878 40.2555 35.7542C42.6078 35.6409 47.4595 35.1614 51.1067 33.1505C51.1067 33.1505 48.8726 35.4855 39.4984 37.1265C39.4742 37.1759 38.922 37.2145 38.8955 37.2651L39.9023 37.3301C39.9023 37.3301 48.3999 36.9687 52.943 33.2048C52.943 33.2048 49.0618 37.3012 46.6589 37.8386C46.6589 37.8386 52.8393 37.4241 55.1204 33.7915C55.1204 33.7915 60.6316 37.406 61.138 42.6844C61.1428 42.688 62.0724 33.7518 52.6066 30.9565Z",
    fill: "#511A18"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6602 33.8406C46.6602 33.8406 50.8354 49.2276 56.0645 50.9867C56.0645 50.9867 63.0913 47.0685 60.3109 38.2491C60.3109 38.2467 55.7016 29.9948 46.6602 33.8406Z",
    fill: "#361414"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2129 48.5676C54.0706 49.482 54.6494 50.3315 55.5054 50.4652C56.3614 50.5989 57.1705 49.9652 57.3139 49.0507C57.4574 48.1362 56.8775 47.2868 56.0214 47.1531C55.1654 47.0194 54.3564 47.6531 54.2129 48.5676Z",
    fill: "#361414"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5612 51.2474C54.5289 51.4789 54.5656 51.7147 54.667 51.9253C54.7683 52.1359 54.9297 52.3119 55.1308 52.4312C55.3319 52.5504 55.5638 52.6076 55.7973 52.5956C56.0309 52.5835 56.2557 52.5028 56.4434 52.3635C56.6312 52.2242 56.7736 52.0325 56.8527 51.8126C56.9318 51.5927 56.9441 51.3543 56.888 51.1274C56.832 50.9005 56.7101 50.6953 56.5376 50.5374C56.3652 50.3796 56.1499 50.2761 55.9188 50.2402C55.6052 50.1943 55.2862 50.2745 55.0317 50.4634C54.7772 50.6522 54.608 50.9341 54.5612 51.2474Z",
    fill: "#361414"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8417 48.0745L56.609 47.5492L56.691 47.86L56.5162 47.7311C56.5162 47.7311 56.7055 48.2444 56.7923 48.5745L56.5584 48.2131C56.5584 48.2131 56.7995 49.0842 56.7742 49.2974L56.6115 48.8155C56.6115 48.8155 56.5898 48.895 56.5584 48.9998C56.6049 49.0709 56.6214 49.1576 56.6042 49.2408C56.5765 49.4227 56.5439 49.6022 56.5005 49.783C56.4877 49.8354 56.462 49.8839 56.4258 49.9239L56.433 49.9552C56.433 49.9552 56.72 49.7769 56.6898 49.1709L56.861 49.7083C56.861 49.7083 56.9551 49.3637 56.7405 48.6299L56.9551 48.8709C56.9036 48.5643 56.8069 48.2671 56.6681 47.989L56.8417 48.0745Z",
    fill: "url(#paint31_linear)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5621 52.353C55.8189 53.0627 56.1336 53.6386 55.8708 54.4121C55.5718 55.2941 54.8327 55.617 54.1033 56.0664C54.2612 55.882 54.5144 55.7435 54.5373 55.476C54.395 55.7278 54.1141 55.8591 53.8838 56.0001C53.9887 55.7531 54.1852 55.5459 54.3155 55.2977C54.1059 55.5063 53.8845 55.7026 53.6523 55.8856C54.0297 55.129 53.1761 54.335 53.7548 53.476C54.1503 52.8868 55.0485 52.4157 55.6767 52.1506",
    fill: "#361414"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M55.826 52.4474C56.2359 52.3486 57.2282 52.145 56.9412 52.8522C56.8014 53.1968 56.9292 53.6956 56.4156 53.7269C55.9731 53.7498 55.6391 53.245 55.457 52.9136L55.4691 52.545L55.826 52.4474Z",
    fill: "url(#paint32_linear)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1538 52.6918C54.9127 52.999 54.2785 53.0171 53.9988 52.7231C53.8782 52.6027 53.8276 52.4027 53.9469 52.2725C53.9952 52.2195 54.1013 52.2533 54.1531 52.1834C54.205 52.1135 54.17 51.9713 54.1652 51.9063C54.1543 51.7496 54.0446 51.5882 54.1784 51.4677C54.3123 51.3472 54.5305 51.4099 54.6607 51.4785C54.8789 51.599 55.325 52.0629 55.2997 52.3352L55.1538 52.6918Z",
    fill: "url(#paint33_linear)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7803 52.465C55.7496 52.3491 55.6806 52.247 55.5846 52.1753C55.4885 52.1035 55.3709 52.0664 55.251 52.0698C55.1532 52.3144 55.0758 52.5667 55.0195 52.824C55.0265 52.8637 55.0416 52.9015 55.0641 52.9349C55.0865 52.9683 55.1157 52.9967 55.1498 53.0181C55.1839 53.0396 55.2221 53.0537 55.2619 53.0595C55.3018 53.0653 55.3425 53.0626 55.3812 53.0518C55.6055 52.9867 55.7152 52.6542 55.7803 52.465Z",
    fill: "url(#paint34_linear)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4727 50.8643L56.2991 50.4751L56.3606 50.704L56.2316 50.6088C56.2316 50.6088 56.3714 50.9896 56.4353 51.2329L56.2629 50.9655C56.2629 50.9655 56.4378 51.6101 56.4221 51.7643L56.3015 51.4113C56.3015 51.4113 56.2858 51.4691 56.2629 51.5474C56.2964 51.5995 56.3085 51.6625 56.2967 51.7233C56.2762 51.8583 56.2521 51.992 56.2195 52.1257C56.2094 52.1638 56.1904 52.1989 56.1641 52.2281V52.2522C56.1641 52.2522 56.3775 52.1197 56.3546 51.6715L56.4824 52.0691C56.4824 52.0691 56.5511 51.8137 56.3943 51.2715L56.5607 51.451C56.5229 51.224 56.4513 51.0039 56.3485 50.798L56.4727 50.8643Z",
    fill: "url(#paint35_linear)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3886 54.3928C54.3886 54.3928 54.1679 54.8181 54.0088 54.8904C54.0088 54.8904 54.2644 55.1012 54.7057 54.594L54.5562 55.0133C54.5562 55.0133 54.7201 55.0687 54.9673 54.6832L54.8431 55.1157C54.8431 55.1157 55.0927 55.1061 55.2965 54.7061L55.2084 55.1145C55.2084 55.1145 55.3965 54.9278 55.5292 54.3783L55.5786 54.6133C55.6582 54.3954 55.7042 54.1667 55.7148 53.935L55.792 54.0555L55.8366 53.6313L55.7751 53.8615L55.71 53.7145C55.71 53.7145 55.6425 54.1145 55.5774 54.3579L55.5605 54.0386C55.5605 54.0386 55.3905 54.6856 55.3013 54.8121L55.3724 54.4446C55.2488 54.5713 55.1158 54.6886 54.9745 54.7952L55.1289 54.2844C55.1289 54.2844 54.8214 54.7434 54.7214 54.694L54.8419 54.2518C54.8419 54.2518 54.5128 54.6567 54.3862 54.5193L54.5718 54.1916C54.5718 54.1916 54.1848 54.4036 54.0896 54.2314L54.274 53.7157L54.1197 53.9567C54.1197 53.9567 53.934 54.3314 53.793 54.3783C53.8744 54.4509 53.979 54.4921 54.0881 54.4948C54.1972 54.4974 54.3037 54.4613 54.3886 54.3928Z",
    fill: "url(#paint36_linear)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1678 35.8006C49.1678 35.8006 41.115 38.9332 37.4883 37.9368C37.4883 37.9368 41.5418 35.5994 42.2013 34.7934C42.8608 33.9873 49.6766 33.8416 49.6766 33.8416L49.1678 35.8006Z",
    fill: "#361414"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M52.6066 30.9565C52.6066 30.9565 44.5912 28.8878 40.2555 35.7542C42.6078 35.6409 47.4595 35.1614 51.1067 33.1505C51.1067 33.1505 48.8726 35.4855 39.4984 37.1265C39.4742 37.1759 38.922 37.2145 38.8955 37.2651L39.9023 37.3301C39.9023 37.3301 48.3999 36.9687 52.943 33.2048C52.943 33.2048 49.0618 37.3012 46.6589 37.8386C46.6589 37.8386 52.8393 37.4241 55.1204 33.7915C55.1204 33.7915 60.6316 37.406 61.138 42.6844C61.1428 42.688 62.0724 33.7518 52.6066 30.9565Z",
    fill: "url(#paint37_linear)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1732 32.2925L48.3625 32.1539C48.3469 32.2473 48.3501 32.3428 48.3721 32.4349C48.394 32.527 48.4342 32.6138 48.4903 32.6901L48.6483 32.4612C48.6823 32.58 48.7444 32.6888 48.8294 32.7786C48.9144 32.8684 49.0197 32.9363 49.1366 32.9768L49.0534 32.6515C49.3801 32.9202 49.8973 32.8214 49.8973 32.8214L49.7358 32.4985C49.8505 32.5685 49.978 32.6151 50.1108 32.6358C50.2436 32.6565 50.3792 32.6507 50.5098 32.619L50.3013 32.3106C50.7487 32.4715 51.2403 32.4595 51.6794 32.2768C51.3659 32.2768 51.009 31.9985 51.009 31.9985C51.4327 32.0229 51.8553 31.9334 52.2328 31.7395C51.9506 31.7587 51.6564 31.5057 51.6564 31.5057L51.3948 31.3539L51.654 31.7322C51.4129 31.925 50.6618 31.9021 50.6618 31.9021L50.9692 32.113C50.6738 32.2877 50.0891 32.0696 50.0891 32.0696L50.2422 32.4081C50.0215 32.4937 49.4971 32.2178 49.4971 32.2178L49.6924 32.6045C49.442 32.5735 49.194 32.5264 48.9497 32.4636L49.01 32.7588C48.8544 32.6853 48.6591 32.184 48.6591 32.184L48.547 32.4732C48.4905 32.3064 48.4501 32.1345 48.4264 31.9599L48.2576 32.1178L48.1841 31.9407L48.1732 32.2925ZM46.7457 33.6419C46.7457 33.6419 46.6866 34.0443 46.5455 34.172C46.5455 34.172 46.9073 34.1913 47.1737 33.6238L47.1906 33.9853C47.1906 33.9853 47.3907 33.9431 47.4944 33.5552L47.5378 33.9166C47.627 33.8634 47.7023 33.7897 47.7574 33.7018C47.8125 33.6138 47.8459 33.514 47.8549 33.4106L47.9333 33.7359C47.9333 33.7359 48.0539 33.5154 47.967 33.0696L48.1202 33.2082C48.1148 33.0233 48.0687 32.8419 47.9851 32.6768L48.1202 32.7214L47.9863 32.4069L48.0177 32.5961L47.8851 32.5262C47.9381 32.6935 47.9816 32.8637 48.0153 33.0359L47.8622 32.8238C47.8622 32.8238 47.9538 33.354 47.9116 33.4841L47.832 33.1961C47.7494 33.3487 47.6555 33.4949 47.5511 33.6335L47.4992 33.2058C47.4992 33.2058 47.3642 33.6732 47.234 33.6877L47.1821 33.3262C47.1821 33.3262 46.9989 33.7672 46.8036 33.7347L46.865 33.4178C46.865 33.4178 46.5359 33.7552 46.3623 33.6817L46.3418 33.2347L46.2791 33.4756C46.2791 33.4756 46.2381 33.825 46.1055 33.9262C46.2271 33.933 46.3486 33.9107 46.4599 33.8613C46.5712 33.8118 46.6692 33.7366 46.7457 33.6419Z",
    fill: "#511A18"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7314 47.2833C41.7314 47.2833 41.7411 46.199 42.8901 47.2917L41.7314 47.2833Z",
    fill: "#ED1F60"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8987 47.313C42.8987 47.313 43.1302 48.2853 42.8047 48.7648L42.8698 48.866C42.8698 48.866 43.9127 48.3504 42.8987 47.313Z",
    fill: "#ED1F60"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7314 47.2832L41.7424 47.2991C41.7381 47.2943 41.7344 47.2889 41.7314 47.2832Z",
    fill: "#951F5F"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8162 48.7871C42.7426 48.7028 42.6715 48.6173 42.6016 48.5305L42.8029 48.798L42.8162 48.7871Z",
    fill: "#951F5F"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2016 48.0064L42.1953 47.9988L42.2016 48.0064Z",
    fill: "#951F5F"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0577 47.4508C42.9011 47.257 42.6755 47.1314 42.4283 47.1002C42.1811 47.069 41.9313 47.1346 41.7314 47.2833C41.7339 47.2893 41.7372 47.295 41.7411 47.3002L42.1944 48.0014L42.2005 48.0086C42.2005 48.0086 42.4271 48.3074 42.6007 48.5363C42.6707 48.6231 42.7418 48.7086 42.8154 48.7929C43.2132 48.4761 43.3603 47.8508 43.0577 47.4508Z",
    fill: "#951F5F"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.0577 47.4508C42.9011 47.257 42.6755 47.1314 42.4283 47.1002C42.1811 47.069 41.9313 47.1346 41.7314 47.2833C41.7339 47.2893 41.7372 47.295 41.7411 47.3002L42.1944 48.0014L42.2005 48.0086C42.2005 48.0086 42.4271 48.3074 42.6007 48.5363C42.6707 48.6231 42.7418 48.7086 42.8154 48.7929C43.2132 48.4761 43.3603 47.8508 43.0577 47.4508Z",
    fill: "#9C1B43"
  }))), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3553 47.091C42.2391 47.0853 42.1227 47.1004 42.0117 47.1356L42.3264 47.4416",
    fill: "url(#paint38_linear)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2969 48.0059C43.3288 48.1681 43.3062 48.3362 43.2327 48.4843C43.1593 48.6324 43.0391 48.7522 42.8906 48.8252C43.0279 48.7398 43.1386 48.618 43.2104 48.4733C43.2822 48.3285 43.3121 48.1667 43.2969 48.0059Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M47.458 38.5007C47.458 38.5007 48.5359 37.8911 48.6215 37.2682C48.6215 37.2682 48.5009 38.8923 47.9343 38.9007L47.458 38.5007Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M48.04 39.2399C48.04 39.2399 49.1022 38.9278 49.1481 37.217C49.1481 37.217 49.3783 39.7339 48.3354 39.9134L48.04 39.2399Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 41.311C48.7661 42.0974 48.5328 42.8661 48.0956 43.5199C47.6584 44.1738 47.037 44.6834 46.31 44.9843C45.5829 45.2853 44.7829 45.364 44.0111 45.2106C43.2393 45.0572 42.5304 44.6785 41.9739 44.1225C41.4175 43.5664 41.0386 42.858 40.885 42.0867C40.7315 41.3154 40.8103 40.516 41.1115 39.7895C41.4126 39.063 41.9226 38.442 42.5769 38.0051C43.2312 37.5682 44.0004 37.3351 44.7874 37.3351C45.8426 37.3351 46.8546 37.7539 47.6008 38.4996C48.3469 39.2452 48.7661 40.2565 48.7661 41.311Z",
    fill: "#AE688E"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 41.9568C48.7661 42.7431 48.5328 43.5119 48.0956 44.1657C47.6584 44.8195 47.037 45.3292 46.31 45.6301C45.5829 45.931 44.7829 46.0098 44.0111 45.8563C43.2393 45.7029 42.5304 45.3243 41.9739 44.7682C41.4175 44.2122 41.0386 43.5037 40.885 42.7324C40.7315 41.9612 40.8103 41.1617 41.1115 40.4352C41.4126 39.7087 41.9226 39.0878 42.5769 38.6509C43.2312 38.214 44.0004 37.9808 44.7874 37.9808C45.8426 37.9808 46.8546 38.3997 47.6008 39.1453C48.3469 39.891 48.7661 40.9023 48.7661 41.9568Z",
    fill: "#FCE7F0"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7661 41.6353C48.7661 42.4217 48.5328 43.1904 48.0956 43.8443C47.6584 44.4981 47.037 45.0077 46.31 45.3086C45.5829 45.6096 44.7829 45.6883 44.0111 45.5349C43.2393 45.3815 42.5304 45.0028 41.9739 44.4468C41.4175 43.8907 41.0386 43.1823 40.885 42.411C40.7315 41.6397 40.8103 40.8403 41.1115 40.1138C41.4126 39.3873 41.9226 38.7663 42.5769 38.3294C43.2312 37.8925 44.0004 37.6594 44.7874 37.6594C45.8426 37.6594 46.8546 38.0783 47.6008 38.8239C48.3469 39.5695 48.7661 40.5808 48.7661 41.6353Z",
    fill: "url(#paint39_radial)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7691 41.5623C45.7693 42.0425 45.627 42.5121 45.3601 42.9115C45.0933 43.3109 44.7139 43.6223 44.2699 43.8062C43.8259 43.9901 43.3373 44.0383 42.866 43.9446C42.3946 43.851 41.9616 43.6198 41.6217 43.2802C41.2819 42.9406 41.0505 42.5079 40.9568 42.0368C40.8631 41.5658 40.9113 41.0775 41.0953 40.6339C41.2794 40.1902 41.5909 39.8111 41.9906 39.5444C42.3903 39.2777 42.8602 39.1355 43.3408 39.1357C43.9847 39.1361 44.6022 39.3918 45.0575 39.8468C45.5128 40.3018 45.7688 40.9188 45.7691 41.5623Z",
    fill: "url(#paint40_radial)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5642 41.6351C44.5642 41.8889 44.4889 42.137 44.3477 42.3481C44.2066 42.5591 44.006 42.7236 43.7713 42.8207C43.5366 42.9178 43.2783 42.9431 43.0292 42.8935C42.7801 42.8439 42.5513 42.7216 42.3718 42.542C42.1922 42.3624 42.07 42.1337 42.0206 41.8847C41.9712 41.6357 41.9968 41.3776 42.0942 41.1432C42.1916 40.9088 42.3563 40.7084 42.5676 40.5676C42.779 40.4267 43.0273 40.3517 43.2814 40.3519C43.4499 40.3519 43.6168 40.3851 43.7726 40.4496C43.9283 40.5141 44.0698 40.6087 44.1889 40.7278C44.308 40.847 44.4025 40.9885 44.4669 41.1441C44.5313 41.2998 44.5644 41.4666 44.5642 41.6351Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7082 40.707C44.7082 40.8214 44.6743 40.9333 44.6106 41.0284C44.547 41.1235 44.4565 41.1977 44.3507 41.2414C44.2449 41.2851 44.1285 41.2965 44.0162 41.2741C43.9039 41.2517 43.8008 41.1965 43.7199 41.1155C43.639 41.0345 43.5839 40.9313 43.5618 40.8191C43.5396 40.7068 43.5512 40.5905 43.5952 40.4848C43.6392 40.3792 43.7135 40.2889 43.8089 40.2255C43.9042 40.1621 44.0162 40.1284 44.1307 40.1287C44.2067 40.1287 44.2819 40.1436 44.352 40.1727C44.4222 40.2018 44.4859 40.2444 44.5395 40.2981C44.5932 40.3518 44.6357 40.4156 44.6646 40.4858C44.6936 40.5559 44.7084 40.6311 44.7082 40.707Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8703 41.7218C44.8703 41.7823 44.8523 41.8415 44.8187 41.8918C44.785 41.9421 44.7372 41.9814 44.6813 42.0045C44.6253 42.0277 44.5637 42.0338 44.5043 42.0219C44.4449 42.0101 44.3903 41.981 44.3475 41.9382C44.3047 41.8954 44.2755 41.8409 44.2637 41.7815C44.2519 41.7221 44.2579 41.6606 44.2811 41.6047C44.3043 41.5488 44.3436 41.501 44.3939 41.4673C44.4443 41.4337 44.5035 41.4158 44.5641 41.4158C44.6453 41.4158 44.7232 41.448 44.7806 41.5054C44.838 41.5628 44.8703 41.6406 44.8703 41.7218Z",
    fill: "white"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.6784 57.5991C53.3197 57.2934 52.9961 56.9487 52.7138 56.5713C52.6162 56.4509 52.5282 56.3219 52.439 56.2015C52.3497 56.081 52.2786 55.9605 52.2075 55.8496C52.1099 55.695 52.0229 55.534 51.947 55.3677C51.8868 55.2147 51.8265 54.5568 51.9036 53.9472C51.9365 53.6752 51.9934 53.4067 52.0736 53.1448C52.152 52.9351 52.2026 52.7978 52.2063 52.7737C52.2206 52.8727 52.2294 52.9725 52.2328 53.0725C52.2401 53.188 52.2563 53.3028 52.281 53.4159C52.2931 53.4785 52.3027 53.5448 52.316 53.611C52.3292 53.6773 52.3521 53.746 52.3714 53.8147C52.498 54.232 52.6518 54.6405 52.832 55.0376C52.8489 55.1026 52.8959 55.2954 52.9526 55.5508C53.0092 55.8063 53.1045 56.1231 53.2106 56.428C53.3167 56.7328 53.4276 57.0304 53.5205 57.246C53.6133 57.4617 53.6784 57.5991 53.6784 57.5991Z",
    fill: "#A0A0A0"
  }))), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8822 22.9616C60.0539 27.6822 62.2422 32.0111 65.7701 32.6292L68.4792 17.1953C64.9514 16.5772 61.7105 18.2459 60.8822 22.9616Z",
    fill: "#C55670"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4816 17.1955L65.7725 32.6295C69.3015 33.2488 72.833 29.9222 73.6613 25.2016C74.4896 20.4811 72.0095 17.8148 68.4816 17.1955Z",
    fill: "#F26283"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6289 33.3259L65.9214 31.7849L66.6111 33.6741L64.6289 33.3259Z",
    fill: "#F26283"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M65.646 33.4266C65.1638 34.3303 64.6743 35.211 64.5127 36.2809C64.1655 38.587 63.94 39.7749 62.3678 41.9015C62.0338 42.3533 61.4912 43.1003 61.2453 43.7256C60.2241 46.322 59.5742 48.763 58.2311 51.2281C57.6704 52.2595 57.5752 53.0354 57.5824 53.9739C57.5824 54.386 57.9984 54.0655 57.9947 53.6498C57.9815 51.8619 59.485 49.8691 60.2301 48.3787C61.3152 46.2208 61.4551 43.8087 62.9742 41.7521C64.7683 39.3303 64.4078 36.5435 65.8426 33.8351C66.0608 33.4218 65.8703 33.0061 65.6509 33.423L65.646 33.4266Z",
    fill: "#3B4350"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8172 20.1644C66.9877 24.8849 69.1772 29.2139 72.705 29.832L75.413 14.398C71.8864 13.7788 68.6455 15.4426 67.8172 20.1644Z",
    fill: "#065FE5"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M75.415 14.3977L72.707 29.8317C76.2349 30.4497 79.7676 27.1244 80.5959 22.4026C81.4242 17.6809 78.9441 15.0158 75.415 14.3977Z",
    fill: "#1C57B1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5615 30.5279L72.854 28.9857L73.5437 30.8748L71.5615 30.5279Z",
    fill: "#F26283"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6688 30.656C71.8755 31.6729 71.0701 32.6596 70.5432 33.9163C69.4075 36.6272 68.7721 38.0224 66.4439 40.3525C65.9496 40.8477 65.143 41.6694 64.6788 42.3839C62.7497 45.3526 61.2643 48.184 59.0567 50.9539C58.1343 52.1118 57.7726 53.0286 57.4639 54.1491C57.3265 54.6431 57.857 54.3142 57.9957 53.8166C58.5864 51.6768 60.8001 49.4949 62.0673 47.8117C63.8999 45.3755 64.8669 42.5104 67.1155 40.261C69.768 37.6103 70.3443 34.2211 72.7243 31.1741C73.086 30.7078 73.033 30.1873 72.6676 30.656H72.6688Z",
    fill: "#3B4350"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3925 50.4153C30.3032 50.984 29.0855 51.4358 27.5941 51.4358C26.1026 51.4358 24.8921 50.9876 24.7969 50.4201L30.3925 50.4153Z",
    fill: "#FFFCEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.3013,
    y1: 57.6756,
    x2: 20.1693,
    y2: 57.3614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -280.321,
    y1: 1515.18,
    x2: -290.875,
    y2: 1511.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 416.634,
    y1: 1346.54,
    x2: 455.723,
    y2: 1346.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.3008,
    y1: 64.9,
    x2: 32.4698,
    y2: 64.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 36.3296,
    y1: 48.2018,
    x2: 36.3814,
    y2: 48.4464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7991C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1575.87,
    y1: 2554.22,
    x2: 2352.87,
    y2: 2554.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1316.54,
    y1: 2531.05,
    x2: 1527.81,
    y2: 2531.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1427.57,
    y1: 2590.46,
    x2: 1714.8,
    y2: 2590.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 27.6156,
    y1: 50.394,
    x2: 27.6156,
    y2: 53.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#752515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#782716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#832E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#953920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E3E23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5321 50.2436) scale(0.912703 0.902944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D27D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E2ABA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FDF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(670.843 596.76) rotate(0.572535) scale(33.9229 14.3277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D27D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E2ABA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FDF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(682.98 594.045) rotate(0.572537) scale(33.9228 14.3278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D27D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E2ABA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FDF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(475.684 799.869) scale(13.8026 13.5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D27D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E2ABA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EFCFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8EAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FDF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1976 45.5682) scale(3.87628 3.87356)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DADBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.234 45.4982) scale(2.36556 2.36389)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#27A6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#26A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2595CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2386BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2173A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1F5C8C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1465.51 2960.5) scale(249.245 249.07)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DADBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(904.619 1821.63) scale(92.8245 92.759)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#27A6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#26A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2595CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2386BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2173A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1F5C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 27.4862,
    y1: 45.0746,
    x2: 27.4862,
    y2: 36.0443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#262627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#444445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6A6B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#98999B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A8AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 27.7254,
    y1: 41.3572,
    x2: 27.7254,
    y2: 37.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#717275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7E7F82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#949597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B2B3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D9D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 27.3793,
    y1: 61.231,
    x2: 27.2987,
    y2: 65.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0E22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 26.418,
    y1: 61.8002,
    x2: 28.2398,
    y2: 61.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F9DF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EC9A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E08B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 134.854,
    y1: 308.088,
    x2: 136.792,
    y2: 308.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F9DF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EC9A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E08B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 228.495,
    y1: 151.699,
    x2: 235.606,
    y2: 151.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F9DF78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EC9A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E08B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D2223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 1174.28,
    y1: 1336.29,
    x2: 1192.12,
    y2: 1329.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: -2291.76,
    y1: 245.76,
    x2: -2308.55,
    y2: 229.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 1204.69,
    y1: 1801.56,
    x2: 1278.35,
    y2: 1801.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: -1586.87,
    y1: 1802.46,
    x2: -1632.04,
    y2: 1802.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 46.3901,
    y1: 57.2162,
    x2: 54.6767,
    y2: 62.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#891D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#811C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#741A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#621818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4A1516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#2E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A1114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 3739.5,
    y1: 2521.22,
    x2: 4694.06,
    y2: 2521.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 2206.86,
    y1: 2226.06,
    x2: 2399.72,
    y2: 2226.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 2470.02,
    y1: 2295.04,
    x2: 2732.17,
    y2: 2295.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 55.8501,
    y1: 46.3648,
    x2: 57.1588,
    y2: 50.7728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D27C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B1E11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 55.9997,
    y1: 52.2954,
    x2: 55.7529,
    y2: 53.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1ABC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E21957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 1109.62,
    y1: 678.081,
    x2: 1112.86,
    y2: 689.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1ABC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E21957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 617.492,
    y1: 462.577,
    x2: 615.392,
    y2: 467.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1ABC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E21957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 154.751,
    y1: 392.211,
    x2: 156.338,
    y2: 439.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D27C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B1E11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 891.705,
    y1: 866.39,
    x2: 882.93,
    y2: 907.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D27C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B1E11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 7176.73,
    y1: 3672.35,
    x2: 11289.7,
    y2: 3672.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D27C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B1E11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 42.0117,
    y1: 47.2657,
    x2: 42.3553,
    y2: 47.2657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEFEFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FCF9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F8F1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F3E5D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ECD7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CEA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6718.64 2774.08) scale(262.758 262.573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F6F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DADBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4086.51 1707.1) scale(97.8587 97.7897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27A8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#27A6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#26A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2595CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2386BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2173A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1F5C8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomersBookParty);
export default __webpack_public_path__ + "static/media/boomers_bookParty.439732f3b832b8597ca87fa2c016edb4.svg";
export { ForwardRef as ReactComponent };